import React, { useEffect, useRef, useState } from "react";
import $ from 'jquery';
import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch'
// import { useHistory } from 'react-router-dom';
import { QueryStringToJSON } from './source.js'
// import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library, IconPrefix, IconName } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import '@fortawesome/fontawesome-svg-core/styles.css'

// Add icons to the library
library.add(fas, far)

// import IAgoraRTC from "agora-rtc-react"
// import {
//     AgoraVideoPlayer,
//     // createClient,
//     // createMicrophoneAndCameraTracks,
//     // createMicrophoneAudioTrack,
//     // createCameraVideoTrack,
// } from "agora-rtc-react";

import IAgoraRTC, {
    AudioEncoderConfiguration,
    MicrophoneAudioTrackInitConfig,
    CameraVideoTrackInitConfig,
    VideoEncoderConfiguration,
    ClientConfig,
    IAgoraRTCRemoteUser,
    ICameraVideoTrack,
    IMicrophoneAudioTrack,
    VideoPlayerConfig,
    UID
} from "agora-rtc-sdk-ng";
import AgoraRTC from "agora-rtc-sdk-ng";

// import AgoraRTM from 'agora-rtm'; // version 2.1.10
// const { RTM } = AgoraRTM;

const Razorpay = require("razorpay");
const RAZORPAY_KEY_ID = "rzp_live_mPOjjzvzG08hts"

// import translation from "../public/json/translation.json";
var translation = require("../public/json/translation.json");
var CryptoJS = require("crypto-js");
// import createClient from "agora-rtc-sdk-ng";
// import createMicrophoneAndCameraTracks from "agora-rtc-sdk-ng";
// import createMicrophoneAudioTrack from "agora-rtc-sdk-ng";
// import createCameraVideoTrack from "agora-rtc-sdk-ng";

// import sanitizeHtml from 'sanitize-html';
// var ReactSafeHtml = require('react-safe-html');

var consoleCSS_green = `color: green; font-size: 18px;`
var consoleCSS_red = `color: red; font-size: 18px;`
var consoleCSS_yellow = `color: yellow; font-size: 18px;`
var consoleCSS = `color: blue; font-size: 18px;`
var consoleCSS_bold = `font-weight: bold;`

const site_url = window.location.origin;
var api_base_url = ''
if (site_url.includes("call-web")) {
    api_base_url = site_url.replaceAll("call-web.", "")
}
else {
    api_base_url = site_url.replace("call", 'api')
}
if (!site_url.includes("http")) {
    api_base_url = `https://${api_base_url}`
}

console.log("The base api url is:", api_base_url)

const appId: string = "bcff0c8af21848c9845e5b62692cc1c0"; //ENTER APP ID HERE
const token: string | null = null;
var full_name: string = 'USER';


var app_data_received = false;
var data_loaded = false
var request_data = {}
var user_id = ''
var uid: UID | string = Number(String(Math.random()).substring(2, 7))
console.log("Created UID is", uid);
const currentTimestamp = Date.now();
var unique_user_id = `${currentTimestamp}-${uid}`
var channel_id = ''
var channel_ids = [];
var call_id = ''
var call_ids = [];
var group_id = ''
var notification_id = ''
var current_call_status = ''
var call_status_state = ''
var network_downstream_speed = ''
var reconnecting_call = 'False'
var reconnect_timeOut;
var calling_back_timeOut;
var retrying_timeout;
var network_interval;
var remote_network_check_started = false;
var user_type = '';
var remote_user_name = {};
var ready_to_join = false;
var user_joined = '0';
var valid_user = true;
var remoteuser_joined = false
var remote_user_joined = false;
var user_disconnected = false;
var client_left = false;
var farmer_company = ''

var trigger_start_call = true;

var web_closed = false;

var joined_users_array: UID[] = [0];


//const razorpay = new Razorpay({
//    key_id: RAZORPAY_KEY_ID,
//    key_secret: RAZORPAY_KEY_SECRET,
//});

// var logo = new Audio(require("../public/images/drpashu_logo.png").default)



var url_query_data = QueryStringToJSON();
console.log("%cThe URL Query Data is:", url_query_data)

var is_call_back = url_query_data['call_back'] === 'true';
var is_paravet_call = url_query_data['paravet_call'] === 'true';

var is_caller = url_query_data['is_caller']

var look_page = url_query_data['page']

var has_page = false;
if (look_page != undefined && look_page != "" && look_page != null) {
    has_page = true;
}

var vet_category = url_query_data["vet_category"]
if (vet_category == null || vet_category == undefined || vet_category == "") {
    vet_category = "OPD"
}
var source = url_query_data['source']
if ((source === null || source === undefined || source === '') && (is_caller === null || is_caller === undefined || is_caller === '')) {
    source = 'self';
}
console.log("source value:", source)

if (is_caller == null || is_caller == undefined || is_caller == '') {
    is_caller = 'true';
}
is_caller = is_caller == 'true';

var use_form = false
if (source === 'self') {
    use_form = true;
}
console.log("use_form value:", use_form)

var cipher_text = String(url_query_data['value']);
var decryptedText = 'None'
var key = "1234567890123456";


var redirect_url = `${site_url}?page=call_history`
if (source != '' && source != null && source != undefined) {
    if (source == 'dehaat') {
        key = "XEDnWRfyLR4otv56";
    }
    const bytes = CryptoJS.AES.decrypt(cipher_text, key, { mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    decryptedText = bytes.toString(CryptoJS.enc.Utf8);
}
else {
    source = ''
}
const url_query_data1 = QueryStringToJSON(decryptedText)

var farmer_name = '';
var mobile = '';
var language = 'en';
var animal = '';

if (url_query_data1['name'] != undefined && url_query_data1['name'] != null) farmer_name = url_query_data1['name'];
if (url_query_data1['mobile'] != undefined && url_query_data1['mobile'] != null) {
    mobile = url_query_data1['mobile']
    if (mobile[0] != '+') {
        mobile = `+91${mobile}`
    }
};
if (url_query_data1['language'] != undefined && url_query_data1['language'] != null) language = url_query_data1['language'];
if (url_query_data1['animal'] != undefined && url_query_data1['animal'] != null) {
    animal = String(url_query_data1['animal']);
    animal = animal[0].toUpperCase() + animal.slice(1);
}


if (url_query_data1['group_id'] != undefined && url_query_data1['group_id'] != null) group_id = url_query_data1['group_id'];;
var call_back_id = url_query_data1['call_id'];

// URL Parameter Support for start_call and join_call
// Usage Examples:
// Start Call: ?start_call=true&user_id=123&name=John&animal_type=Cow&language=en&mobile=+919876543210&vet_category=OPD&source=web
// Join Call: ?join_call=true&call_id=abc123&channel_id=xyz789&user_id=456&user_role=receiver
var url_start_call = url_query_data['start_call'] === 'true';
var url_join_call = url_query_data['join_call'] === 'true';
var url_call_id = url_query_data['call_id'] || '';
var url_channel_id = url_query_data['channel_id'] || '';
var url_user_id = url_query_data['user_id'] || '';
var url_user_role = url_query_data['user_role'] || '';
var url_name = url_query_data['name'] || '';
var url_mobile = url_query_data['mobile'] || '';
var url_language = url_query_data['language'] || '';
var url_animal_type = url_query_data['animal_type'] || '';
var url_vet_category = url_query_data['vet_category'] || '';
var url_source = url_query_data['source'] || '';

console.log("URL Parameters detected:", {
    start_call: url_start_call,
    join_call: url_join_call,
    call_id: url_call_id,
    channel_id: url_channel_id,
    user_id: url_user_id,
    user_role: url_user_role,
    name: url_name,
    mobile: url_mobile,
    language: url_language,
    animal_type: url_animal_type,
    vet_category: url_vet_category,
    source: url_source
});

// Set global flags for URL parameter usage
var using_url_params = url_start_call || url_join_call;

// Test function for URL parameter functionality (can be called from browser console)
window.testUrlParams = function () {
    console.log("Testing URL Parameter functionality:");
    console.log("Current URL:", window.location.href);
    console.log("Parsed URL params:", url_query_data);
    console.log("Using URL params:", using_url_params);
    console.log("Start call:", url_start_call);
    console.log("Join call:", url_join_call);

    if (using_url_params) {
        console.log("URL parameters will be used for call initiation");
        if (url_start_call) {
            console.log("Expected message: 'Waiting for Vet to Join'");
        } else if (url_join_call) {
            console.log("Expected message: 'Connecting to Call...'");
        }
    } else {
        console.log("Fallback to existing Android/encrypted parameter logic");
    }
};


if (is_caller && (source != '' && source != null && source != undefined)) {
    // try{
    //     const data = {
    //         'user_id': unique_user_id,
    //         'source': source,
    //         'action': 'create',
    //         'farmer_name': farmer_name,
    //         'mobile': mobile,
    //         'language': language,
    //         'animal': animal,
    //     }
    //     $.ajax({
    //         type: 'POST',
    //         url: `${api_base_url}/api/website_call_report`,
    //         data: data,
    //         cache: false,
    //         crossDomain: true,
    //         success: function (result, status, xhr) {
    //         },
    //         error: function (xhr, status, error) {
    //         }
    //     });
    // }
    // catch{}
}

var is_direct_call = false;
var is_follow_up_call = false;
var recalling = false
var user_role = '';

var edit_prescription = false;
if (is_caller) {
    edit_prescription = false
}
else if (is_call_back) {
    edit_prescription = true;
}
else {
    edit_prescription = true;
}

var ringing_sound = new Audio(require("../public/audio/ringing.mp3").default)
ringing_sound.volume = 1;
ringing_sound.loop = true;


// Enable log upload
AgoraRTC.enableLogUpload();
// Set the log output level
AgoraRTC.setLogLevel(0);

const config: ClientConfig = {
    mode: "rtc",
    codec: "vp8"
};
// using the hook to get access to the RTC client object
const rtcClient = AgoraRTC.createClient(config);

// Initialize RTM client
// var rtmClient = new RTM(appId, String(uid));


function getTranslatedText(key, lang) {
    const text = translation[String(key)];
    var translate_text = ''
    if (text == undefined || text == null || text == '') {
        translate_text = ''
    }
    else {
        const translated_text = text[String(lang)];
        if (translated_text == undefined || translated_text == null || translated_text == '') {
            translate_text = text['en']
        }
        else {
            translate_text = text[lang]
        }
    }
    console.log(`translate_text for ${key} and ${lang}: ${translate_text}:`, text);
    return translate_text;
}

function translatePage(dist_language) {
    const language_dict = translation;
    for (key in language_dict) {
        let translate_text = language_dict[key][dist_language]
        if (translate_text != '' && translate_text != undefined && translate_text != null) {
            $(`.${key}`).html(translate_text)
            $(`#${key}`).html(translate_text)
        }
    }
}

function readCookies(value) {
    try {
        const cookieValue = document.cookie.split("; ").find((row) => row.startsWith(`${value}=`))?.split("=")[1];
        return cookieValue;
    }
    catch {
        return '';
    }
}


window.androidData = (received_data) => {
    console.log('%cThe Received Data from Android is:', consoleCSS)
    console.log(received_data)
    const runAction_event = new CustomEvent("runAction", {
        detail: {
            data: received_data,
        },
    });
    window.dispatchEvent(runAction_event)
}
var last_data_sent_to_app = ''
var data_to_app = {}
var running_on_android = false
function webData(web_data) {
    // const rtcClient = useClient();
    data_to_app = web_data
    if (!web_data.hasOwnProperty('platform_test')) {
        if (web_data.hasOwnProperty('name')) {
            last_data_sent_to_app = web_data.name
            if (!(web_data.hasOwnProperty('request'))) {
                web_data['request'] = web_data['name']
            }
        }
        if (web_data.hasOwnProperty('status')) {
            if (['error', 'call_failed'].includes(web_data.status) && web_closed) {
                return null
            }
            if (['error', 'call_failed'].includes(web_data.status)) {
                web_closed = true;
                user_joined = ''
                clearTimeout(reconnect_timeOut)
                clearTimeout(calling_back_timeOut)
                clearInterval(waiting_call_fetch_interval);
                try {
                    ringing_sound.volume = 0;
                    ringing_sound.pause();
                } catch { }
                try {
                    if ((rtcClient.remoteUsers.length === 0 && (user_call_api_status_started === false && user_agent_call_api_status_started == false)) || web_data['name'] == 'choosed_ivr_call') {
                        clearInterval(timer_interval);
                        rtcClient.removeAllListeners();
                        rtcClient.leave();
                        // we close the tracks to perform cleanup
                        if (local_tracks) local_tracks[0].close();
                        if (local_tracks) local_tracks[1].close();
                        if (!running_on_android) {
                            window.location.replace(redirect_url);
                        }
                    }
                    else {
                        current_call_status = 'call_success'
                        return null;
                    }
                } catch { }
                console.log(`Call Failed or Error. Stop Ringing.....`)
            }
            if (web_data.status == 'call_success') {
                if (!running_on_android) {
                    // window.location.replace(document.referrer);
                    window.location.replace(redirect_url)
                }
            }
        }
        console.log('%cThe Data to be send to Android is:', consoleCSS)
        console.log(web_data)
    }
    try {
        const webdata = JSON.stringify(web_data)
        window.Android.webData(webdata);
        running_on_android = true
        return true;
    }
    catch (e) {
        // console.error(e)
        running_on_android = false;
        console.log("Not running in Android")
        if (web_data['name'] == 'start_call') {
            const runAction_event = new CustomEvent("runAction", {
                detail: {
                    data: {
                        name: 'start_call',
                        data: {
                            web_call: true,
                            user_id: 'anonymous',
                            name: farmer_name,
                            animal_type: animal,
                            language: language,
                            mobile: mobile,
                            vet_category: vet_category,
                            source: source
                        }
                    },
                },
            });
            window.dispatchEvent(runAction_event)
        }
        else if (web_data['name'] == 'call_back') {
            const runAction_event = new CustomEvent("runAction", {
                detail: {
                    data: {
                        name: 'call_back',
                        data: {
                            web_call: true,
                            user_id: sessionStorage.getItem("User_id"),
                            name: farmer_name,
                            group_id: group_id,
                            call_id: call_back_id,
                            source: source
                        }
                    },
                },
            });
            window.dispatchEvent(runAction_event)
        }
        return false;
    }
}


// Function to trigger calls from URL parameters
function triggerUrlParameterCall() {
    if (url_start_call) {
        console.log("Triggering start_call from URL parameters");

        // Validate required parameters for start_call
        if (!url_user_id && !url_name && !farmer_name) {
            console.warn("start_call from URL requires user_id or name parameter");
            return false;
        }

        const runAction_event = new CustomEvent("runAction", {
            detail: {
                data: {
                    name: 'start_call',
                    data: {
                        web_call: true,
                        user_id: url_user_id || 'anonymous',
                        user_role: url_user_role || 'caller',
                        name: url_name || farmer_name,
                        animal_type: url_animal_type || animal,
                        language: url_language || language,
                        mobile: url_mobile || mobile,
                        vet_category: url_vet_category || vet_category,
                        source: url_source || source || 'url_params'
                    }
                },
            },
        });
        window.dispatchEvent(runAction_event);
        return true;
    }
    else if (url_join_call) {
        console.log("Triggering join_call from URL parameters");

        // Validate required parameters for join_call
        if (!url_call_id && !url_channel_id) {
            console.warn("join_call from URL requires call_id or channel_id parameter");
            return false;
        }

        const runAction_event = new CustomEvent("runAction", {
            detail: {
                data: {
                    name: 'join_call',
                    data: {
                        call_id: url_call_id,
                        channel_id: url_channel_id,
                        user_id: url_user_id || 'anonymous',
                        user_role: url_user_role || 'receiver'
                    }
                },
            },
        });
        window.dispatchEvent(runAction_event);
        return true;
    }
    return false;
}

// var platform_test = webData({platform_test: true})
// var use_form = false
// if(platform_test == false && source == 'self'){
//     use_form = true
// }

var ivr_call_clicked = false;
function start_ivr_call(reason = '') {
    if (!ivr_call_clicked) {
        ivr_call_clicked = true;
        const data = {
            'user_id': user_id,
            'call_id': call_id,
            'reason': reason
        }
        console.log(`Request Data of ${api_base_url}/ivr/ivr_app_call/ for user ${user_type} is: `, data)
        try {
            $.post(`${api_base_url}/ivr/ivr_app_call/`, data, function (response) {
                console.log(`Response Body of ${api_base_url}/ivr/ivr_app_call/ for user ${user_type} is: `, response)
                // resolve(response)
            });
        }
        catch {
            // resolve('failed')
        }
        rtcClient.removeAllListeners();
        rtcClient.leave();
        let message = `<i class="fa-regular fa-spinner-third fa-spin"></i> Loading.....`;
        showAlert({ title: "", message: message, hide_close: true, error: true });
        let msg = "You will receive a call on your mobile number to connect with the user. Kindly pick the call."
        setTimeout(function () {
            webData({ 'status': 'call_failed', 'name': 'choosed_ivr_call', 'message': msg, 'call_id': call_id, 'group_id': group_id, 'channel_id': channel_id, 'sl': '00', })
        }, 3000);
    }
}
$(document).on('click', '.start-ivr-call', function (event) {
    const reason = $(this).data('pressed');
    start_ivr_call(reason);
})

$(document).on('click', '.not-ivr-call', function (event) {
    webData({ 'status': 'error', 'name': 'close_web_error', 'message': '', 'call_id': call_id, 'group_id': group_id, 'channel_id': channel_id, 'sl': '00', })
});

var call_end_clicked = false;
$(document).on('click', '#confirm-yes', function (event) {
    if (!call_end_clicked) {
        call_end_clicked = true;
        alert_callback();
    }
});

$(document).on('click', '#confirm-continue', function () {
    $(".alert-container").hide();
    agentCall();
});

$(document).on('click', '.close-alert', function (event) {
    alert_callback = () => { };
    $(".alert-container").hide();
});

$(document).on('click', '.start-ivr-call-btn-icon', function (event) {
    let message = "Click this button to make a phone call. This video call will be disconnected and you will receive a phone call in few minutes.";
    showAlert({ title: "Make Phone Call without Internet", message: message, hide_close: false, call_offline_footer: true, error: false });
});

$(document).on('click', '.start-support-call-btn-icon', function () {
    let message = "Do you want to connect the call with an agent to explain the benifits of your recommended products to the animal owner?";
    showAlert({ title: "Start Support Call", message: message, hide_close: false, continue_footer: true, error: false });
});


var available_languages = [['en', 'English'], ['hi', 'Hindi (हिंदी)'], ['as', 'Assamese (অসমীয়া)'], ['bn', 'Bangla (বাংলা)'], ['kn', 'Kannada (ಕನ್ನಡ)'], ['mr', 'Marathi (मराठी)'], ['ta', 'Tamil (தமிழ்)'], ['te', 'Telugu (తెలుగు)'], ['gu', 'Gujarati (ગુજરાતી)'], ['ml', 'Malayalam (മലയാളം)'], ['pa', 'Punjabi (ਪੰਜਾਬੀ)'], ['od', 'Odia (ଓଡିଆ)']]
var available_animals = {
    'Farm': ['Chicken', 'Cow', 'Buffalo', 'Pig', 'Goat', 'Sheep'],
    'Pet': ['Dog', 'Cat']
}

var user_form_submitted = false;
var user_second_report = false;
$(document).on('submit', '#user-form', function (event) {
    event.preventDefault();
    farmer_name = String($("#input_name").val());
    mobile = String($("#input_mobile").val());
    document.cookie = `farmer_name=${farmer_name}; max-age=31536000`;
    document.cookie = `mobile=${mobile}; max-age=31536000`;
    mobile = `+91${mobile}`
    if (!user_second_report) {
        user_second_report = true;
        // try{
        //     const data = {
        //         'user_id': unique_user_id,
        //         'action': 'form3',
        //         'mobile': mobile,
        //         'farmer_name': farmer_name,
        //     }
        //     $.ajax({
        //         type: 'POST',
        //         url: `${api_base_url}/api/website_call_report`,
        //         data: data,
        //         cache: false,
        //         crossDomain: true,
        //         success: function (result, status, xhr) {
        //         },
        //         error: function (xhr, status, error) {
        //         }
        //     });
        // }
        // catch{}
    }
    if (!user_form_submitted && tracks_ready) {
        user_form_submitted = true;
        $("#input_submit").prop('disabled', true);
        const txt = getTranslatedText('input_submiting', language)
        $("#input_submit").html(txt)
        // webData(request_data);
        $.ajax({
            type: 'POST',
            url: `${api_base_url}/api/vet_list`,
            headers: {
                'User-id': 'anonymous',
            },
            data: {
                animal_type: animal,
                name: farmer_name,
                language: language,
                mobile: mobile,
                create_order: true,
            },
            cache: false,
            crossDomain: true,
            success: async function (result, status, xhr) {
                console.log('Vet List response:', result)
                const vet_list = result['data']['vet_list']
                if (vet_list.length > 0) {
                    const order_details = result['data']['order_details']
                    if (order_details != null && order_details != undefined) {
                        // const order_options = {
                        //     amount: amount * 100,
                        //     currency: "INR",
                        //     receipt: shortid.generate(),
                        //     payment_capture: 1,
                        //     partial_payment: false,
                        // };
                        // const order = await razorpay.orders.create(order_options);
                        // console.log("The created payment order:", order);
                        const payment_option = {
                            key: RAZORPAY_KEY_ID,
                            amount: order_details['data']['amount'],
                            currency: "INR",
                            // name: "DrPashu Vet Consultation",
                            description: "24/7 online vet consultation",
                            order_id: order_details['data']['id'],
                            //image: {logo},
                            prefill: {
                                name: farmer_name,
                                email: "void@razorpay.com",
                                contact: mobile,
                            },
                            retry: {
                                enabled: false,
                            },
                            timeout: 900, // Time limit in Seconds
                            notes: {
                                name: "Vet Consultation",
                                language_Chose: language,
                                animal_Chose: animal,
                                mobile: mobile
                            },
                            handler: async function (response) {
                                $.ajax({
                                    type: 'POST',
                                    url: `${api_base_url}/api/add_money`,
                                    headers: {
                                        'User-id': mobile,
                                    },
                                    data: {
                                        amount: order_details['data']['amount'] / 100,
                                        reference_no: response.razorpay_payment_id,
                                    },
                                    cache: false,
                                    crossDomain: true,
                                    success: async function (result, status, xhr) {
                                    },
                                    error: function (xhr, status, error) {
                                    }
                                });
                                console.log("payment handler", response)
                                webData(request_data);
                            },
                            modal: {
                                confirm_close: true, // this is set to true, if we want confirmation when clicked on cross button.
                                ondismiss: async (reason) => {
                                    // Reason 1 - when payment is cancelled. It can happend when we click cross icon or cancel any payment explicitly. 
                                    if (reason === undefined) {
                                        console.log('cancelled', reason);
                                        user_form_submitted = false;
                                        $("#input_submit").prop('disabled', false);
                                        const btn_txt = getTranslatedText('input_submit', language)
                                        $("#input_submit").html(btn_txt)
                                    }
                                    // Reason 2 - When modal is auto closed because of time out
                                    else if (reason === 'timeout') {
                                        console.log('timeout', reason);
                                        user_form_submitted = false;
                                        $("#input_submit").prop('disabled', false);
                                        const btn_txt = getTranslatedText('input_submit', language)
                                        $("#input_submit").html(btn_txt)
                                    }
                                    // Reason 3 - When payment gets failed.
                                    else {
                                        console.log('failed', reason);
                                        user_form_submitted = false;
                                        $("#input_submit").prop('disabled', false);
                                        const btn_txt = getTranslatedText('input_submit', language)
                                        $("#input_submit").html(btn_txt)
                                    }
                                },
                            }
                        }
                        console.log("payment_option:", payment_option)
                        const paymentObject = new window.Razorpay(payment_option);

                        // If you want to retreive the chosen payment method.
                        paymentObject.on('payment.submit', (response) => {
                            console.log("payment.submit", response)
                        });

                        // To get payment id in case of failed transaction.
                        paymentObject.on('payment.failed', (response) => {
                            console.log("payment.failed", response)
                            user_form_submitted = false;
                            $("#input_submit").prop('disabled', true);
                            const btn_txt = getTranslatedText('input_submit', language)
                            $("#input_submit").html(btn_txt)
                        });
                        paymentObject.open();
                    }
                    else {
                        webData(request_data);
                    }
                }
                else {
                    const busy_msg = "All our vets are currently busy.<br>You may also try again later"
                    showAlert({ title: getTranslatedText('inconvenience_title', language), message: busy_msg, error: false });
                    user_form_submitted = false;
                    $("#input_submit").prop('disabled', false);
                    const btn_txt = getTranslatedText('input_submit', language)
                    $("#input_submit").html(btn_txt)
                }
            },
            error: function (xhr, status, error) {
            }
        });
    }
});


$(document).on('click', '.language-list-item', function () {
    $(".language-list").remove();
    $(".animal-list").show();
    language = $(this).data('value');
    translatePage(language);
    // try{
    //     const data = {
    //         'user_id': unique_user_id,
    //         'action': 'form1',
    //         'language': language,
    //     }
    //     $.ajax({
    //         type: 'POST',
    //         url: `${api_base_url}/api/website_call_report`,
    //         data: data,
    //         cache: false,
    //         crossDomain: true,
    //         success: function (result, status, xhr) {
    //         },
    //         error: function (xhr, status, error) {
    //         }
    //     });
    // }
    // catch{}
});
$(document).on('click', '.animal-list-item', function () {
    $(".animal-list").remove();
    $("#user-form").show();
    animal = $(this).data('value');
    // try{
    //     const data = {
    //         'user_id': unique_user_id,
    //         'action': 'form2',
    //         'animal': animal,
    //     }
    //     $.ajax({
    //         type: 'POST',
    //         url: `${api_base_url}/api/website_call_report`,
    //         data: data,
    //         cache: false,
    //         crossDomain: true,
    //         success: function (result, status, xhr) {
    //         },
    //         error: function (xhr, status, error) {
    //         }
    //     });
    // }
    // catch{}
});


const AlertDialog = (props: any) => {
    return <>
        <div className="alert-container">
            <div className="alert-box">
                <div className="close-div d-flex justify-content-end" id="close-alert"><i className="fa-regular fa-xmark close-icon"></i></div>
                <div className="alert-heading"></div>
                <div className="alert-content"></div>
                <div className="alert-footer alert-box-btn" id="alert-footer-call_mobile">
                    <div className="d-flex justify-content-between alert-footer-flex">
                        <div className="footer-button-1 start-ivr-call" data-pressed="Call Mobile">Call Mobile</div>
                        <div className="footer-button-2 not-ivr-call">Not Now</div>
                    </div>
                </div>
                <div className="alert-footer alert-box-btn" id="alert-footer-call_offline">
                    <div className="d-flex justify-content-between alert-footer-flex">
                        <div className="footer-button-1 start-ivr-call" data-pressed="Call Offline">Call Offline</div>
                        <div className="footer-button-2 close-alert">Not Now</div>
                    </div>
                </div>
                <div className="alert-footer alert-txt-btn" id="alert-footer-yes_no">
                    <div className="d-flex justify-content-center alert-footer-flex">
                        <div className="footer-button-1 close-alert">No</div>
                        <div className="footer-button-2" id="confirm-yes">Yes</div>
                    </div>
                </div>
                <div className="alert-footer alert-box-btn" id="alert-footer-continue">
                    <div className="d-flex justify-content-center alert-footer-flex">
                        <div className="footer-button-1 close-alert">Cancel</div>
                        <div className="footer-button-2 confirm-continue" id="confirm-continue">Continue</div>
                    </div>
                </div>

                <div className="alert-footer alert-box-btn" id="alert-footer-okay">
                    <div className="d-flex justify-content-center alert-footer-flex">
                        <div className="footer-button footer-button-1 close-alert">Close</div>
                        <div className="footer-button footer-button-2 confirm-continue" id="confirm-continue-okay">Okay</div>
                    </div>
                </div>
            </div>
        </div>
    </>
}
var alert_callback = () => { };
function showAlert(parameter = {}) {
    if (parameter['alertCallback'] == undefined || parameter['alertCallback'] == null) {
        alert_callback = () => { };
    }
    else {
        alert_callback = parameter['alertCallback'];
    }
    $(".alert-heading").html(parameter['title']);
    $(".alert-content").html(parameter['message']);
    console.log(`ALERT MESSAGE: `, parameter);
    if (parameter['error'] == true) {
        try {
            user_joined = ''
            try {
                ringing_sound.volume = 0;
                ringing_sound.pause();
            } catch { }
            // const rtcClient = useClient();
            if (rtcClient.remoteUsers.length === 0 && (user_call_api_status_started === false && user_agent_call_api_status_started == false)) {
                $(".App").html('')
                rtcClient.removeAllListeners();
                rtcClient.leave();
                if (local_tracks) local_tracks[0].close();
                if (local_tracks) local_tracks[1].close();
            }
            else {
                current_call_status = 'call_success'
            }
        }
        catch { }
    }
    $(".alert-footer").hide();
    if (parameter['call_mobile_footer'] == true) {
        $("#alert-footer-call_mobile").show();
    }

    if (parameter['call_offline_footer'] == true) {
        $("#alert-footer-call_offline").show();
    }
    if (parameter['yes_no_footer'] == true) {
        $("#alert-footer-yes_no").show();
    }
    if (parameter['continue_footer'] == true) {
        $("#alert-footer-continue").show();
    }
    if (parameter['okay_footer'] == true) {
        $("#alert-footer-okay").show();
    }

    $(".alert-container").show();
    if (parameter['hide_close'] == true) {
        // $(".close-div").hide();
        $(".close-icon").hide();
        // $("#close-alert").hide();
    }
    else {
        // $(".close-div").show();
        $(".close-icon").show();
        // $("#close-alert").show(); 
    }
}
$(document).on('click', '.close-icon', function (el) {
    $(".alert-container").hide();
    alert_callback();
});

$(document).on("click", "#alert-footer-okay .footer-button", function (e) {
    $(".alert-container").hide();
})

var timer_started = false;
var timer_str = ''
var timer_interval;
var reverse_timer = false;
var start_time = 0;
async function timer(reverse = false, start = 0) {
    if (!timer_started) {
        timer_interval = setInterval(async function () {
            timer_str = new Date(start * 1000).toISOString().substring(11, 19);
            $(".top-fixed-bar").html(timer_str);
            if (reverse) {
                start -= 1
                if (start < 0) {
                    // await leave_Channel('client', false);
                }
            }
            else {
                start += 1
            }
        }, 1000);
    }
    timer_started = true;
}

var farmer_mobile = '';
var vet_mobile = ''

function fetchUserDetails(user_id) {
    let promise = new Promise((resolve, reject) => {
        let response_data = {}
        const data = {
            'user_id': user_id,
        }
        try {
            $.post(`${api_base_url}/api/get_user_data`, data, function (response) {
                response_data = response
                resolve(response_data)
            });
        }
        catch {
            response_data = {}
            resolve(response_data)
        }
    });
    return promise;
}

var waiting_call_fetch_interval;
var waiting_call_fetch_interval_count = 0;
function fetchCallDetails() {
    let promise = new Promise((resolve, reject) => {
        var user_index = rtcClient.remoteUsers.length;
        const remote_user_uid = joined_users_array[user_index]
        if (remote_user_name[`${remote_user_uid}`] == 'User' || remote_user_name[`${remote_user_uid}`] == undefined || remote_user_name[`${remote_user_uid}`] == null) {
            if (user_index > 0) {
                try {
                    try {
                        ringing_sound.volume = 0;
                        ringing_sound.pause();
                    } catch { }
                    if ($(`.remote_user_name-${remote_user_uid}`).length == 0) {
                        fetchCallDetails()
                    }
                    waiting_call_fetch_interval_count += 1;
                    if (waiting_call_fetch_interval_count <= 5) {
                        console.log(`Fetching remote user details to display ${user_type}`)
                        let response_data = {}
                        const data = {
                            'mobile': mobile,
                            'user_id': user_id,
                            'user_type': user_type,
                            'call_id': call_id,
                            'channel_id': channel_id,
                            'group_id': group_id,
                        }
                        console.log(`Request Data of /api/get-call-data/ for user ${user_type} is: `, data)
                        try {
                            $.post(`${api_base_url}/api/get-call-data`, data, function (response_data) {
                                // console.log(`%cThe details of the user ${uid} is:`, consoleCSS)
                                // console.log(data)
                                sessionStorage.setItem("User_id", response_data["User_id"]);
                                sessionStorage.setItem("mobile_number", response_data["mobile_number"]);
                                console.log(`Response Body of /api/get-call-data/ for user ${user_type} is: `, response_data)
                                const remote_user_name_res = response_data['remote_user_name'][`user_${user_index}`]
                                if (remote_user_name_res == '') {
                                    remote_user_name[`${remote_user_uid}`] = 'User'
                                    fetchCallDetails()
                                }
                                remote_user_name[`${remote_user_uid}`] = remote_user_name_res
                                $(`.remote_user_name-${remote_user_uid}`).html(remote_user_name[`${remote_user_uid}`]);
                                $(`.remote_user_name_${remote_user_uid}`).html(remote_user_name[`${remote_user_uid}`]);
                                console.log(`Displayed ${remote_user_name[`${remote_user_uid}`]} in .remote_user_name-${remote_user_uid}`)
                                full_name = remote_user_name[`${remote_user_uid}`]
                                edit_prescription = response_data['edit_prescription']
                                farmer_mobile = response_data['farmer_mobile']
                                vet_mobile = response_data['vet_mobile']
                                // const message = `Full Name: ${full_name}`;
                                // const payload = { type: "text", message: message };
                                // const publishMessage = JSON.stringify(payload);
                                // try {
                                //     const result = rtmClient.publish(channel_id, publishMessage);
                                //     console.log("result: rtmClient.publish -", result);
                                // } catch (status) {
                                //     console.log("error: rtmClient.publish -", status);
                                // }
                                resolve(response_data)
                            });
                        }
                        catch {
                            // reject("Failed to fetch user's name");
                            if (remote_user_name[`${remote_user_uid}`] == 'User') {
                                fetchCallDetails()
                            }
                            resolve({})
                        }
                        console.log(`Fetched remote user name to display ${user_type} is: `, response_data);
                    }
                }
                catch (e) {
                    resolve('ok')
                }
            }
        }
    });
    return promise;
}

function showTost(message) {
    console.log('%cThe Tost Message to be shown is:', consoleCSS)
    console.log(message)
    const data = {
        'action': 'show_tost',
        'message': message,
    }
    webData(data);
}
function closeWeb(status) {
    const data = {
        'action': 'close_web',
        'status': status,
        'sl': '01',
    }
    webData(data);
}

var sid = '';
var resourceId = '';

var callStatusSocket;
var callStatusSocket_closed = true;
var last_api_call_status = ''
var user_call_api_status_started = false;
var user_call_api_status_ended = false

function connectWebSocket(url) {
    return new Promise((resolve, reject) => {
        const socket = new WebSocket(url);

        // Resolve the Promise when the connection opens
        socket.onopen = () => {
            console.log("WebSocket connection opened.");
            resolve(socket);
        };

        // Reject the Promise on error
        socket.onerror = (error) => {
            console.error("WebSocket error: ", error);
            reject(error);
        };

        // Optionally handle connection closed
        socket.onclose = (event) => {
            console.log("WebSocket connection closed: ", event);
            callStatusSocket_closed = true;
        };
    });
}

function api_CallStatusUpdate(callStatus = '', userId = '', triggerd_from = '') {
    return new Promise(async (resolve, reject) => {
        var call_status_api_ws = `wss://${api_base_url.replaceAll('https://', '').replaceAll('http://', '')}/ws/call_status_update/${channel_id}/`;
        last_api_call_status = callStatus;

        if (callStatusSocket_closed) {
            callStatusSocket = await connectWebSocket(call_status_api_ws)
            callStatusSocket_closed = false;
        }

        if (callStatus == 'Started') {
            user_call_api_status_started = true
            try {
                ringing_sound.volume = 0;
                ringing_sound.pause();
            } catch { }
        }
        if (callStatus == 'Ended') {
            user_call_api_status_ended = true
        }
        let call_status_api = ''
        call_status_api = `${api_base_url}/api/call_status_update`
        const data = {
            // 'action': 'call_status_update',
            'mobile': mobile,
            'call_status': callStatus,
            'call_id': call_id,
            'userId': userId,
            'uid': uid,
            'sid': sid,
            'resourceId': resourceId,
            'channel_id': channel_id,
            'group_id': group_id,
            // 'video': recorded_blob,
            'remote_user_name': remote_user_name,
            'is_caller': is_caller,
            'triggerd_from': triggerd_from,
            'recalling': recalling,
            'ready_to_join': ready_to_join,
            'user_joined': user_joined,
            'current_call_status': current_call_status,
            'call_status_state': call_status_state,
            'web_error': data_to_app['error'],
            'web_message': data_to_app['message'],
            'call_end_clicked': call_end_clicked
        }

        if (userId !== '' && call_id != '' && valid_user) {

            callStatusSocket.onmessage = function (e) {
                const socket_response = JSON.parse(e.data);
                console.log(`Received data of ${call_status_api_ws} for user-id ${user_id} is: `, socket_response)
                const socket_message = socket_response['message'];
                const socket_data = socket_response['data'];
                if (socket_message['userId'] == userId) {
                    if (socket_data['call_status'] == 'Started') {
                        sid = socket_data['sid'];
                        resourceId = socket_data['resourceId'];
                        fetchCallDetails();
                    }
                    resolve('Success')
                }
            };

            console.log(`Sent data of ${call_status_api_ws} for user-id ${user_id} is: `, data)
            callStatusSocket.send(JSON.stringify({
                'message': data
            }));

            // $.ajax(
            // {
            //     type: 'POST',
            //     url: call_status_api,
            //     headers: {
            //         'User-id': userId,
            //         // 'Content-Type': 'application/json'
            //     },
            //     data: data,
            //     // contentType: false,
            //     // processData: false,
            //     // dataType: 'multipart/form-data',
            //     // dataType: 'json',
            //     cache: false,
            //     crossDomain: true,
            //     success: function (result, status, xhr) {
            //         console.log(`Response Body of ${call_status_api} for user-id ${user_id} is: `, result)
            //         sid = result['data']['sid']
            //         resourceId = result['data']['resourceId']
            //         if(callStatus == 'Started'){
            //             fetchCallDetails()
            //         }
            //         resolve('Success')
            //     },
            //     error: function (xhr, status, error) {
            //         console.error(xhr)
            //         console.error(status)
            //         console.error(error)
            //         console.log(xhr.statusCode)
            //         resolve('Unsuccess')
            //     }
            // });
        }
        else {
            resolve('No action performed')
        }
    });
}


var last_api_agen_call_status = ''
var user_agent_call_api_status_started = false;
var user_agent_call_api_status_ended = false
function api_AgentCallStatusUpdate(callStatus = '', userId = '', triggerd_from = '') {
    return new Promise(async (resolve, reject) => {
        last_api_agen_call_status = callStatus;
        if (callStatus == 'Started') {
            user_agent_call_api_status_started = true
            try {
                ringing_sound.volume = 0;
                ringing_sound.pause();
            } catch { }
        }
        if (callStatus == 'Ended') {
            user_agent_call_api_status_ended = true
        }
        let call_status_api = ''
        call_status_api = `${api_base_url}/api/call_status_update`
        const data = {
            // 'action': 'call_status_update',
            'mobile': mobile,
            'call_status': callStatus,
            'call_id': agent_call_id,
            'userId': userId,
            'uid': uid,
            'sid': sid,
            'resourceId': resourceId,
            'channel_id': channel_id,
            'group_id': group_id,
            // 'video': recorded_blob,
            'remote_user_name': remote_user_name,
            'is_caller': is_caller,
            'triggerd_from': triggerd_from,
            'recalling': recalling,
            'ready_to_join': ready_to_join,
            'user_joined': user_joined,
            'current_call_status': current_call_status,
            'call_status_state': call_status_state,
            'web_error': data_to_app['error'],
            'web_message': data_to_app['message'],
            'call_end_clicked': call_end_clicked
        }
        console.log(`Request Body of ${call_status_api} for user-id ${user_id} is: `, data)
        if (userId !== '' && call_id != '' && valid_user) {
            // var formData = new FormData();
            // for ( var key in data ) {
            //     formData.append(key, data[key]);
            // }
            $.ajax(
                {
                    type: 'POST',
                    url: call_status_api,
                    headers: {
                        'User-id': userId,
                        // 'Content-Type': 'application/json'
                    },
                    data: data,
                    // contentType: false,
                    // processData: false,
                    // dataType: 'multipart/form-data',
                    // dataType: 'json',
                    cache: false,
                    crossDomain: true,
                    success: function (result, status, xhr) {
                        console.log(`Response Body of ${call_status_api} for user-id ${user_id} is: `, result)
                        sid = result['data']['sid']
                        resourceId = result['data']['resourceId']
                        if (callStatus == 'Started') {
                            fetchCallDetails()
                        }
                        resolve('Success')
                    },
                    error: function (xhr, status, error) {
                        console.error(xhr)
                        console.error(status)
                        console.error(error)
                        console.log(xhr.statusCode)
                        resolve('Unsuccess')
                    }
                });
        }
        else {
            resolve('No action performed')
        }
    });
}


var call_rejected = false;
function api_rejectCall() {
    return new Promise((resolve, reject) => {
        call_rejected = true;
        const data = {
            // 'action': 'call_status_update',
            'callid': call_id,
            'notificationId': notification_id,
            'mobile': mobile
        }

        console.log(`Request Body of /api/call_reject_api/ for user-id ${user_id} is: `, data)
        if (user_id != '' && call_id != '' && valid_user) {
            $.ajax(
                {
                    type: 'POST',
                    url: `${api_base_url}/api/call_reject_api`,
                    headers: {
                        'User-id': user_id,
                    },
                    data: data,
                    // contentType: false,
                    // processData: true,
                    dataType: 'json',
                    cache: false,
                    crossDomain: true,
                    success: function (result, status, xhr) {
                        console.log(`Response Body of /api/call_reject_api/ for user-id ${user_id} is: `, result)
                        resolve('Success')
                    },
                    error: function (xhr, status, error) {
                        console.error(xhr)
                        console.error(status)
                        console.error(error)
                        console.log(xhr.statusCode)
                        resolve('Error')
                    }
                });
        }
        else {
            resolve('No action performed')
        }
    });
}

var joinedUsers = {}

var set_microphone = true;
var seted_microphone_label: 'Speaker' | 'Headset earpiece' = 'Speaker'
var tracks_ready: Boolean = false;
var local_tracks: [IMicrophoneAudioTrack, ICameraVideoTrack] | null;
var cameras: MediaDeviceInfo[] = [];
var media_devices: MediaDeviceInfo[] = [];
var playbackDevices: MediaDeviceInfo[] = [];
var media_tracks: MediaStreamTrack[] = [];

function getMediaTracks() {
    return new Promise<MediaStreamTrack[]>((resolve, reject) => {
        navigator.mediaDevices
            .getUserMedia({
                audio: {
                    autoGainControl: true,
                    echoCancellation: true,
                    noiseSuppression: true,
                },
                video: {
                    // resizeMode: 'none',
                    autoGainControl: true,
                    echoCancellation: true,
                    noiseSuppression: true,
                    // facingMode: {
                    //     exact: cameraVideoTrackConfig.facingMode,
                    // },
                },
            })
            .then((mediaStream) => {
                const mediaTracks = mediaStream.getTracks();
                const inputAudioTracks = mediaStream.getAudioTracks();
                const inputVideoTracks = mediaStream.getVideoTracks();
                const mediatracks = [inputAudioTracks[0], inputVideoTracks[0]];
                // resolve({
                //     'mediaTracks': mediaTracks,
                //     'inputAudioTracks': inputAudioTracks,
                //     'inputVideoTracks': inputVideoTracks,
                // })
                resolve(mediaTracks)
            })
            .catch((error) => {
                console.error(`Error happened: ${error}`);
                // reject(new Error(`${error}`))
                reject(error)
            });
    })
}

// if(media_devices.length == 0){
//     try{
//         await AgoraRTC.getDevices(false).then((devices) => {
//             media_devices = devices;
//             console.log('Media devices are: ', devices);
//         });
//     }
//     catch{

//     }
// }

var videoEncoderConfig: VideoEncoderConfiguration = {
    height: 100
}
var localVideoPlayerConfig: VideoPlayerConfig = {
    mirror: false
}
interface MediaTracksConfiguration {
    microphoneAudioTrackConfig: MicrophoneAudioTrackInitConfig;
    cameraVideoTrackConfig: CameraVideoTrackInitConfig;
}
var audioEncoderConfig: AudioEncoderConfiguration = {
    bitrate: 320, //kbps
    sampleRate: 192000, // 192 KHz
    stereo: true,
}
var microphoneAudioTrackConfig: MicrophoneAudioTrackInitConfig = {
    // AEC: true, //Enable acoustic echo cancellation
    // AGC: true, // Enable audio gain control
    // ANS: true, // Enable automatic noise suppression
    encoderConfig: audioEncoderConfig,
}
var cameraVideoTrackConfig: CameraVideoTrackInitConfig = {
    facingMode: 'user', // front or rear camera
    // optimizationMode: 'motion', // Prioritizes video smoothness
    // encoderConfig: videoEncoderConfig,
}

var video_loaded = false;
var network_check_timeout;
var network_check_timeout_bool = false;
var offline_call_popup_showed = false
function showNetworkQuality(UID, netwoekQuality, local_user_info = false) {
    let down_netwoek_quality = Number(netwoekQuality.downlinkNetworkQuality)
    let down_diff_netwoek_quality = 6 - down_netwoek_quality;
    if (down_netwoek_quality == 0) {
        down_diff_netwoek_quality = 0
    }
    $(`.signal-icon-${UID} .download .signal-bar`).css('opacity', '10%')
    if (down_diff_netwoek_quality > 0) {
        var i;
        for (i = 1; i <= down_diff_netwoek_quality + 1; i++) {
            $(`.signal-icon-${UID} .download .signal-bar:nth-child(${i})`).css('opacity', '100%')
        }
    }
    if (down_diff_netwoek_quality >= 3) {
        $(`.signal-icon-${UID} .arrow-down-icon`).css('opacity', '100%');
        clearTimeout(network_check_timeout);
        network_check_timeout_bool = false;
    }
    else {
        $(`.signal-icon-${UID} .arrow-down-icon`).css('opacity', '10%')
        if (offline_call_popup_showed == false && video_loaded && !network_check_timeout_bool) {
            network_check_timeout_bool = true;
            network_check_timeout = setTimeout(function () {
                $(".start-ivr-call-btn-popover").show().delay(10000).fadeOut(1000);
                // $("#start-ivr-call-btn").popover('show')
                console.log("Show IVR popover");
                // offline_call_popup_showed = true;
            }, 3000);
        }
    }
    let up_netwoek_quality = Number(netwoekQuality.uplinkNetworkQuality)
    let up_diff_netwoek_quality = 6 - up_netwoek_quality;
    if (up_netwoek_quality == 0) {
        up_diff_netwoek_quality = 0
    }
    $(`.signal-icon-${UID} .upload .signal-bar`).css('opacity', '10%')
    if (up_diff_netwoek_quality > 0) {
        let i;
        for (i = 1; i <= up_diff_netwoek_quality + 1; i++) {
            $(`.signal-icon-${UID} .upload .signal-bar:nth-child(${i})`).css('opacity', '100%')
        }
    }
    if (up_diff_netwoek_quality >= 3) {
        $(`.signal-icon-${UID} .arrow-up-icon`).css('opacity', '100%')
    }
    else {
        $(`.signal-icon-${UID} .arrow-up-icon`).css('opacity', '10%')
    }
}

var volume_check_timeout;
var volume_check_timeout_bool = false;
function setAudioVolume(v_uid, volume) {
    let audio_volume = Number(volume)
    let off_volume = `${100 - audio_volume}%`;
    $(`#volume-indicator-${String(v_uid).replaceAll(/ /g, "_")} .off-background`).css('height', off_volume);

    if (v_uid != uid && video_loaded) {
        if (audio_volume < 30) {
            if (offline_call_popup_showed == false && video_loaded && !volume_check_timeout_bool) {
                volume_check_timeout_bool = true;
                volume_check_timeout = setTimeout(function () {
                    $(".start-ivr-call-btn-popover").show().delay(10000).fadeOut(1000);
                    // $("#start-ivr-call-btn").popover('show')
                    console.log("Show IVR popover");
                    // offline_call_popup_showed = true;
                }, 3000);
            }
        }
        else {
            volume_check_timeout_bool = false;
            clearTimeout(volume_check_timeout);
        }
    }
}

var agent_call_id = ''
var agent_call_performed: boolean | string = ''
function agentCall(recalling = false) {
    let message = `<i class="fa-sharp fa-solid fa-spinner fa-spin"></i> We're connecting the call to an agent...`;
    showAlert({ title: "Please Wait", message: message, hide_close: true, error: false });
    const data = {
        'source_call': call_id,
        'channel_id': channel_id,
        'support_id': 1,
        'animal_type': animal,
    }
    if (!recalling) {
        data['reconnecting_call'] = 'False'
    }
    else {
        data['reconnecting_call'] = 'True'
    }
    $.ajax(
        {
            type: 'POST',
            url: `${api_base_url}/api/start_vet_support_call`,
            headers: {
                'User-id': user_id,
            },
            data: data,
            dataType: 'json',
            cache: false,
            crossDomain: true,
            success: function (result, status, xhr) {
                console.log('start_vet_support_call response', result)
                clearTimeout(reconnect_timeOut);

                if (result['status'] === true) {
                    agent_call_performed = true;
                    if (result['message'] === 'Success') {
                        // await leaveClient()
                        const data = result.data
                        farmer_company = data['farmer_company']
                        if (data['channel_id'] != '' && data['channel_id'] != null && data['channel_id'] != undefined) {
                            channel_id = data['channel_id']
                        }
                        if (data['callId'] != '' && data['callId'] != null && data['callId'] != undefined) {
                            agent_call_id = data['callId']
                        }
                        if (data['notificationId'] != '' && data['notificationId'] != null && data['notificationId'] != undefined) {
                            notification_id = data['notificationId']
                        }
                        if (rtcClient.remoteUsers.length <= 1) {
                            reconnect_timeOut = setTimeout(function () {
                                if (rtcClient.remoteUsers.length <= 1) {
                                    console.log("Reconnecting.................................")
                                    agentCall(true)
                                    return true;
                                }
                                else {
                                    clearTimeout(reconnect_timeOut);
                                }
                            }, 55000);
                        }
                        else {
                            clearTimeout(reconnect_timeOut);
                        }
                    }
                }
                else {
                    clearTimeout(reconnect_timeOut);
                    console.log(`Call Not Picked. Stop Ringing.....`)
                    if (result.hasOwnProperty('message')) {
                        showAlert({ title: getTranslatedText('inconvenience_title', language), message: result.message, error: false });
                    }
                    else {
                        let message = 'Failed to start the call'
                        showAlert({ title: getTranslatedText('inconvenience_title', language), message: message, error: false });
                    }
                }
            },
            error: function (xhr, status, error) {
                console.error(xhr)
                console.error(status)
                console.error(error)
                console.log(xhr.statusCode)
                clearTimeout(reconnect_timeOut);
                console.log(`Start Call Error. Stop Ringing.....`)
                if (xhr.status !== 0) {
                    let message = 'Fatching issue to start the call'
                    showAlert({ title: getTranslatedText('inconvenience_title', language), message: message, error: false });
                }
            }
        });
}

function vet_list(user_phone) {
    let promise = new Promise((resolve, reject) => {
        let response_data = {}
        try {
            $.ajax(
                {
                    type: 'POST',
                    url: `${api_base_url}/api/start_vet_support_call`,
                    headers: {
                        'User-id': "anonymous",
                    },
                    data: {
                        animal_type: animal,
                    },
                    dataType: 'json',
                    cache: false,
                    crossDomain: true,
                    success: function (result, status, xhr) {
                    }
                });
        }
        catch {
            response_data = {}
            resolve(response_data)
        }
    });
    return promise;
}

var runed_one_time = false;
var sdk_initialized = false;
var total_joined_users = 0;
const App = () => {
    console.log('%cComponent: App', `${consoleCSS_yellow}${consoleCSS_bold}`)
    // history = useHistory();
    const [trackStatus, updateTrackStatus] = useState({ ready: false, tracks: local_tracks });
    // const rtcClient = useClient();

    // const [camera, changeCamera] = useState<'user' | 'environment'>('user')
    // const mediaConfig = await mediaInputConfig(camera)

    console.log("%cThe audio input configurations:", consoleCSS)
    console.log(microphoneAudioTrackConfig)
    console.log("%cThe video input configurations:", consoleCSS)
    console.log(cameraVideoTrackConfig)

    // const useCameraTrack = createCameraVideoTrack(cameraVideoTrackConfig)
    // const useMicrophoneTrack = createMicrophoneAudioTrack(microphoneAudioTrackConfig)
    if (!trackStatus.ready && !has_page) {
        let message = `<i class="fa-regular fa-spinner-third fa-spin"></i> Checking microphone and camera.....`;
        // showAlert({title:"", message:message, hide_close:true, error:false});
        $(".loading_message").html(`Checking microphone and camera.....`);
        if (is_caller && (source != '' && source != null && source != undefined)) {
            // try{
            //     const data = {
            //         'user_id': unique_user_id,
            //         'action': 'permission',
            //         'permission': 'Asked',
            //     }
            //     $.ajax({
            //         type: 'POST',
            //         url: `${api_base_url}/api/website_call_report`,
            //         data: data,
            //         cache: false,
            //         crossDomain: true,
            //         success: function (result, status, xhr) {
            //         },
            //         error: function (xhr, status, error) {
            //         }
            //     });
            // }
            // catch{}
        }
        const trackState = AgoraRTC.createMicrophoneAndCameraTracks(microphoneAudioTrackConfig, cameraVideoTrackConfig)
            .then((audio_video_track) => {
                let ret_res = {
                    ready: true,
                    tracks: audio_video_track
                }
                $(".loader-container").hide();
                console.log('Microphone and Camera are:', audio_video_track);
                if (is_caller && (source != '' && source != null && source != undefined)) {
                    // try{
                    //     const data = {
                    //         'user_id': unique_user_id,
                    //         'action': 'permission',
                    //         'permission': 'Allowed',
                    //     }
                    //     $.ajax({
                    //         type: 'POST',
                    //         url: `${api_base_url}/api/website_call_report`,
                    //         data: data,
                    //         cache: false,
                    //         crossDomain: true,
                    //         success: function (result, status, xhr) {
                    //         },
                    //         error: function (xhr, status, error) {
                    //         }
                    //     });
                    // }
                    // catch{}
                }
                updateTrackStatus(ret_res)
                return ret_res
            })
            .catch((error) => {
                $(".loader-container").hide();
                console.error(error)
                if (is_caller && (source != '' && source != null && source != undefined)) {
                    // try{
                    //     const data = {
                    //         'user_id': unique_user_id,
                    //         'action': 'permission',
                    //         'permission': 'Denied',
                    //     }
                    //     $.ajax({
                    //         type: 'POST',
                    //         url: `${api_base_url}/api/website_call_report`,
                    //         data: data,
                    //         cache: false,
                    //         crossDomain: true,
                    //         success: function (result, status, xhr) {
                    //         },
                    //         error: function (xhr, status, error) {
                    //         }
                    //     });
                    // }
                    // catch{}
                }
                if (!use_form) {
                    let message = 'Microphone and Camera permission is not granted.<br>Please allow the permissions.'
                    let callback = () => { webData({ 'status': 'error', 'name': 'close_web_error', 'message': message, 'call_id': call_id, 'group_id': group_id, 'channel_id': channel_id, 'sl': '00', }) }
                    showAlert({ title: "Permission Denied", message: message, alertCallback: callback, error: true });
                }
            });
    }

    // ready is a state variable, which returns true when the local tracks are initialized, untill then tracks variable is null
    // const trackState = useMicrophoneAndCameraTracks();
    tracks_ready = trackStatus.ready
    local_tracks = trackStatus.tracks
    // if(set_microphone){
    //     const temp_array = seted_microphone_label.split(" ")
    //     media_devices.forEach(async (device) => {
    //         if(device.kind != 'videoinput'){
    //             const mic_label = device.label.toLowerCase().replaceAll(' ', '')
    //             temp_array.some(async (label) => {
    //                 label = label.toLowerCase().replaceAll(' ', '');
    //                 if(mic_label.includes(label)){
    //                     if(local_tracks){
    //                         local_tracks[0].setDevice(device.deviceId);
    //                         console.log('Microphone set to:', device);
    //                         set_microphone = false;
    //                         return 1;
    //                     }
    //                 }
    //             })
    //         }
    //     });
    // }

    const [callStatus, updateCallStatus] = useState('Not Initiated');
    call_status_state = callStatus

    console.log(`%cThe Current CALL Status-1 is: ${callStatus}\nIs Caller ${is_caller}`, consoleCSS)

    const [renderSL, forceRender] = useState<number>(1);

    if (rtcClient.remoteUsers.length > 0) {
        clearTimeout(reconnect_timeOut);
        clearTimeout(calling_back_timeOut)
        try {
            ringing_sound.volume = 0;
            ringing_sound.pause();
        } catch { }
    }

    useEffect(() => {
        console.log('%cComponent: App --> useEffect', consoleCSS)
        if (!runed_one_time) {
            runed_one_time = true;
            window.addEventListener('runAction', async function (e: any) {
                // e.stopImmediatePropagation();
                app_data_received = true;
                let eventData = e.detail.data
                // Check if user_role came from URL parameters first
                if (url_user_role && url_user_role !== '') {
                    user_role = String(url_user_role);
                } else {
                    user_role = String(eventData.data['user_role'])
                }
                console.log('Triggering the action event:', eventData);
                // let eventData = e.detail.data.data
                for (let key in eventData.data) {
                    if (String(eventData.data[key]) === 'true') {
                        eventData.data[key] = 'True'
                    }
                    else if (String(eventData.data[key]) === 'false') {
                        eventData.data[key] = 'False'
                    }
                }

                try {
                    if (user_id == '') {
                        // Check if user_id came from URL parameters first
                        if (url_user_id && url_user_id !== '') {
                            user_id = url_user_id;
                        } else {
                            user_id = eventData.data['user_id']
                        }

                        const user_details = await fetchUserDetails(user_id);
                        if (user_details && (language == '' || language == undefined || language == null)) {
                            language = user_details['lang_code']
                        }

                    }
                }
                catch {
                }
                $(".loading_message").html(`Starting.....`);
                if (eventData.name === 'start_call' && is_caller && trigger_start_call) {
                    edit_prescription = false;
                    trigger_start_call = false;
                    clearTimeout(reconnect_timeOut);
                    if (!recalling) {
                        eventData.data['reconnecting_call'] = 'False'
                    }
                    else {
                        eventData.data['reconnecting_call'] = 'True'
                    }
                    if (group_id === '') {
                        const date = new Date()
                        group_id = `${date.toLocaleString('default', { day: '2-digit' })}${date.toLocaleString('default', { month: '2-digit' })}${date.toLocaleString('default', { year: '2-digit' })}${date.toLocaleString('default', { hour: '2-digit', hourCycle: 'h24' })}${date.toLocaleString('default', { minute: '2-digit' })}${date.toLocaleString('default', { second: '2-digit' })}`
                    }
                    eventData.data['group_id'] = group_id
                    const onlyContainsNumbers = /^\d+$/.test(String(eventData.data['vet_category']));
                    if (onlyContainsNumbers) {
                        is_paravet_call = true;
                    }
                    let start_call_api = ''
                    if (is_paravet_call) {
                        start_call_api = `${api_base_url}/api/paravet_start_call`
                        eventData.data['service_id'] = eventData.data['vet_category']
                    }
                    else {
                        start_call_api = `${api_base_url}/api/start_call`
                    }
                    console.log(`Request Body of ${start_call_api} is: `, eventData.data)
                    $.ajax(
                        {
                            type: 'POST',
                            url: start_call_api,
                            headers: {
                                'User-id': user_id,
                            },
                            data: eventData.data,
                            // contentType: false,
                            // processData: true,
                            dataType: 'json',
                            cache: false,
                            crossDomain: true,
                            success: function (result, status, xhr) {
                                console.log('start_call response', result)
                                clearTimeout(reconnect_timeOut);

                                if (result['status'] === true) {
                                    if (result['message'] === 'Success') {
                                        // await leaveClient()
                                        user_joined = '0';
                                        const data = result.data
                                        farmer_company = data['farmer_company']
                                        if (data['channel_id'] != '' && data['channel_id'] != null && data['channel_id'] != undefined) {
                                            channel_id = data['channel_id']
                                        }
                                        if (data['callId'] != '' && data['callId'] != null && data['callId'] != undefined) {
                                            call_id = data['callId']
                                        }
                                        if (data['notificationId'] != '' && data['notificationId'] != null && data['notificationId'] != undefined) {
                                            notification_id = data['notificationId']
                                        }
                                        if (data['first_free_call'] == true && data['free_call_limit'] != '' && data['free_call_limit'] != null && data['free_call_limit'] != undefined) {
                                            reverse_timer = true;
                                            start_time = Number(data['free_call_limit'])
                                        }
                                        full_name = data['full_name'];
                                        ready_to_join = true;
                                        if (rtcClient.remoteUsers.length === 0 && user_call_api_status_started === false && remoteuser_joined === false) {
                                            reconnect_timeOut = setTimeout(function () {
                                                if (rtcClient.remoteUsers.length === 0 && user_call_api_status_started === false && remoteuser_joined === false) {
                                                    console.log("Reconnecting.................................")
                                                    recalling = true;
                                                    trigger_start_call = true;
                                                    window.androidData(eventData)
                                                    return true;
                                                }
                                                else {
                                                    user_joined = ''
                                                    try {
                                                        ringing_sound.volume = 0;
                                                        ringing_sound.pause();
                                                    } catch { }
                                                }
                                            }, 55000);
                                        }
                                        else {
                                            user_joined = ''
                                            try {
                                                ringing_sound.volume = 0;
                                                ringing_sound.pause();
                                            } catch { }
                                        }
                                        updateCallStatus('Ready')
                                    }
                                }
                                else {
                                    user_joined = '';
                                    try {
                                        ringing_sound.volume = 0;
                                        ringing_sound.pause();
                                    } catch { }
                                    const data = result.data
                                    if (data['callId'] != '' && data['callId'] != null && data['callId'] != undefined) {
                                        call_id = data['callId']
                                    }
                                    clearTimeout(reconnect_timeOut);
                                    clearTimeout(calling_back_timeOut)
                                    console.log(`Call Not Picked. Stop Ringing.....`)
                                    if (result.hasOwnProperty('message')) {
                                        current_call_status = 'call_failed'
                                        let callback = () => { webData({ 'status': 'error', 'name': 'close_web_error', 'message': result.message, 'call_id': call_id, 'group_id': group_id, 'channel_id': channel_id, 'sl': '00', }) }
                                        showAlert({ title: getTranslatedText('inconvenience_title', language), message: result.message, alertCallback: callback, error: true });
                                    }
                                    else {
                                        current_call_status = 'call_failed'
                                        let message = 'Failed to start the call'
                                        let callback = () => { webData({ 'status': 'error', 'name': 'close_web_error', 'message': message, 'call_id': call_id, 'group_id': group_id, 'channel_id': channel_id, 'sl': '06', }) }

                                        showAlert({ title: getTranslatedText('inconvenience_title', language), message: message, alertCallback: callback, error: true });
                                    }
                                }
                            },
                            error: function (xhr, status, error) {
                                console.error(xhr)
                                console.error(status)
                                console.error(error)
                                console.log(xhr.statusCode)
                                user_joined = '';
                                clearTimeout(reconnect_timeOut);
                                clearTimeout(calling_back_timeOut)
                                try {
                                    ringing_sound.volume = 0;
                                    ringing_sound.pause();
                                } catch { }
                                console.log(`Start Call Error. Stop Ringing.....`)
                                if (xhr.status !== 0) {
                                    current_call_status = 'error'
                                    let message = 'Fatching issue to start the call'
                                    let callback = () => { webData({ 'status': 'error', 'name': 'close_web_error', 'message': message, 'error': `Server Error in /api/start_call.`, 'call_id': call_id, 'group_id': group_id, 'channel_id': channel_id, 'sl': '04', }) }
                                    showAlert({ title: getTranslatedText('inconvenience_title', language), message: message, alertCallback: callback, error: true });
                                }
                            }
                        });
                    if (rtcClient.remoteUsers.length === 0 && user_call_api_status_started === false && remoteuser_joined === false) {
                        updateCallStatus('Waiting')
                    }
                }

                else if (eventData.name === 'call_back') {
                    is_call_back = true;
                    // edit_prescription = true;
                    if (group_id === '') {
                        const date = new Date()
                        group_id = `${date.toLocaleString('default', { day: '2-digit' })}${date.toLocaleString('default', { month: '2-digit' })}${date.toLocaleString('default', { year: '2-digit' })}${date.toLocaleString('default', { hour: '2-digit', hourCycle: 'h24' })}${date.toLocaleString('default', { minute: '2-digit' })}${date.toLocaleString('default', { second: '2-digit' })}`
                    }
                    eventData.data['group_id'] = group_id
                    let call_back_api = ''
                    call_back_api = `${api_base_url}/api/call_back`
                    console.log(`Request Body of ${call_back_api} is: `, eventData.data)
                    $.ajax(
                        {
                            type: 'POST',
                            url: call_back_api,
                            headers: {
                                'User-id': user_id,
                            },
                            data: eventData.data,
                            // contentType: false,
                            // processData: true,
                            dataType: 'json',
                            cache: false,
                            crossDomain: true,
                            success: function (result, status, xhr) {
                                console.log('call_back response', result)
                                calling_back_timeOut = setTimeout(function () {
                                    console.log("45 seconds reached!")
                                    if (rtcClient.remoteUsers.length === 0 && user_call_api_status_started === false) {
                                        console.log("The user doesn't picked up the call.")
                                        try {
                                            ringing_sound.volume = 0;
                                            ringing_sound.pause();
                                        } catch { }
                                        var ivr_call_msg = ``;
                                        var ivr_footer = false;
                                        if (call_id != '' && call_id != null && call_id != undefined) {
                                            ivr_footer = true;
                                            ivr_call_msg = `<br>Do you want to call their mobile number?`
                                        }
                                        let message = "The user has not picked your call on the App."
                                        let msg = `${message}${ivr_call_msg}`
                                        let callback = () => { webData({ 'status': 'error', 'name': 'close_web_error', 'message': message, 'call_id': call_id, 'group_id': group_id, 'channel_id': channel_id, 'sl': '00', }) }
                                        showAlert({ title: getTranslatedText('inconvenience_title', language), message: msg, call_mobile_footer: ivr_footer, alertCallback: callback, error: true });
                                        clearTimeout(calling_back_timeOut)
                                    }
                                    else {
                                        user_joined = ''
                                    }
                                }, 55000);
                                if (result['status'] === true) {
                                    const data = result.data
                                    farmer_company = data['farmer_company']
                                    if (data['channel_id'] != '' && data['channel_id'] != null && data['channel_id'] != undefined) {
                                        channel_id = data['channel_id']
                                    }
                                    if (data['callId'] != '' && data['callId'] != null && data['callId'] != undefined) {
                                        call_id = data['callId']
                                    }
                                    if (data['notificationId'] != '' && data['notificationId'] != null && data['notificationId'] != undefined) {
                                        notification_id = data['notificationId']
                                    }
                                    full_name = data['full_name'];
                                    ready_to_join = true;
                                    updateCallStatus('Ready')
                                }
                                else {
                                    user_joined = ''
                                    try {
                                        ringing_sound.volume = 0;
                                        ringing_sound.pause();
                                    } catch { }
                                    const data = result.data
                                    if (data['callId'] != '' && data['callId'] != null && data['callId'] != undefined) {
                                        call_id = data['callId']
                                    }
                                    console.log(`Call back failed. Stop Ringing.....`)
                                    clearTimeout(reconnect_timeOut);
                                    clearTimeout(calling_back_timeOut)
                                    if (result.hasOwnProperty('message')) {
                                        current_call_status = 'call_failed'
                                        var ivr_call_msg = ``;
                                        var ivr_footer = false;
                                        if (call_id != '' && call_id != null && call_id != undefined) {
                                            ivr_footer = true;
                                            ivr_call_msg = `<br>Do you want to call their mobile number?`
                                        }
                                        let msg = `${result.message}${ivr_call_msg}`
                                        let message = 'Failed to initiate the call back'
                                        let callback = () => { webData({ 'status': 'error', 'name': 'close_web_error', 'message': message, 'call_id': call_id, 'group_id': group_id, 'channel_id': channel_id, 'sl': '00', }) }
                                        showAlert({ title: getTranslatedText('inconvenience_title', language), message: msg, call_mobile_footer: ivr_footer, alertCallback: callback, error: true });
                                    }
                                    else {
                                        current_call_status = 'call_failed'
                                        let message = 'Failed to initiate the call back'
                                        let callback = () => { webData({ 'status': 'error', 'name': 'close_web_error', 'message': message, 'call_id': call_id, 'group_id': group_id, 'channel_id': channel_id, 'sl': '06', }) }
                                        showAlert({ title: getTranslatedText('inconvenience_title', language), message: message, alertCallback: callback, error: true });
                                    }
                                }
                            },
                            error: function (xhr, status, error) {
                                console.error(xhr)
                                console.error(status)
                                console.error(error)
                                console.log(xhr.statusCode)
                                user_joined = ''
                                clearTimeout(reconnect_timeOut);
                                clearTimeout(calling_back_timeOut)
                                try {
                                    ringing_sound.volume = 0;
                                    ringing_sound.pause();
                                } catch { }
                                console.log(`Call back error. Stop Ringing.....`)
                                if (xhr.status !== 0) {
                                    current_call_status = 'error'
                                    let message = 'Fatching issue to initiate the call back'
                                    let callback = () => { webData({ 'status': 'error', 'name': 'close_web_error', 'message': message, 'error': message, 'call_id': call_id, 'group_id': group_id, 'channel_id': channel_id, 'sl': '07', }) }
                                    showAlert({ title: getTranslatedText('inconvenience_title', language), message: message, alertCallback: callback, error: true });
                                }
                            }
                        });
                    updateCallStatus('Waiting')
                }

                else if ((eventData.name === 'direct_call' || eventData.name === 'follow_up_call') && is_caller) {
                    edit_prescription = false;
                    let direct_call_api = ''
                    if (eventData.name === 'direct_call') {
                        is_direct_call = true;
                        direct_call_api = `${api_base_url}/api/direct_call`
                    }
                    else if (eventData.name === 'follow_up_call') {
                        is_follow_up_call = true;
                        direct_call_api = `${api_base_url}/api/follow_up_call`
                    }
                    if (group_id === '') {
                        const date = new Date()
                        group_id = `${date.toLocaleString('default', { day: '2-digit' })}${date.toLocaleString('default', { month: '2-digit' })}${date.toLocaleString('default', { year: '2-digit' })}${date.toLocaleString('default', { hour: '2-digit', hourCycle: 'h24' })}${date.toLocaleString('default', { minute: '2-digit' })}${date.toLocaleString('default', { second: '2-digit' })}`
                    }
                    eventData.data['group_id'] = group_id

                    console.log(`Request Body of ${direct_call_api} is: `, eventData.data)
                    $.ajax(
                        {
                            type: 'POST',
                            url: direct_call_api,
                            headers: {
                                'User-id': user_id,
                            },
                            data: eventData.data,
                            // contentType: false,
                            // processData: true,
                            dataType: 'json',
                            cache: false,
                            crossDomain: true,
                            success: function (result, status, xhr) {
                                console.log('direct call response', result)
                                calling_back_timeOut = setTimeout(function () {
                                    console.log("45 seconds reached!")
                                    if (rtcClient.remoteUsers.length === 0 && user_call_api_status_started === false) {
                                        console.log("The vet/paravet doesn't picked up the call.")
                                        try {
                                            ringing_sound.volume = 0;
                                            ringing_sound.pause();
                                        } catch { }
                                        var ivr_call_msg = ``;
                                        var ivr_footer = false;
                                        if (call_id != '' && call_id != null && call_id != undefined) {
                                            ivr_footer = true;
                                            ivr_call_msg = `<br>Do you want to call their mobile number?`
                                        }
                                        let message = "The user has not picked your call on the App."
                                        let msg = `${message}${ivr_call_msg}`
                                        let callback = () => { webData({ 'status': 'error', 'name': 'close_web_error', 'message': message, 'error': message, 'call_id': call_id, 'group_id': group_id, 'channel_id': channel_id, 'sl': '08', }) }
                                        showAlert({ title: getTranslatedText('inconvenience_title', language), message: msg, call_mobile_footer: ivr_footer, alertCallback: callback, error: true });
                                        // clearTimeout(calling_back_timeOut)
                                    }
                                    else {
                                        user_joined = ''
                                    }
                                }, 55000);
                                if (result['status'] === true) {
                                    const data = result.data
                                    farmer_company = data['farmer_company']
                                    if (data['channel_id'] != '' && data['channel_id'] != null && data['channel_id'] != undefined) {
                                        channel_id = data['channel_id']
                                    }
                                    if (data['callId'] != '' && data['callId'] != null && data['callId'] != undefined) {
                                        call_id = data['callId']
                                    }
                                    if (data['notificationId'] != '' && data['notificationId'] != null && data['notificationId'] != undefined) {
                                        notification_id = data['notificationId']
                                    }
                                    full_name = data['full_name'];
                                    ready_to_join = true;
                                    updateCallStatus('Ready')
                                }
                                else {
                                    user_joined = ''
                                    try {
                                        ringing_sound.volume = 0;
                                        ringing_sound.pause();
                                    } catch { }
                                    const data = result.data
                                    if (data['callId'] != '' && data['callId'] != null && data['callId'] != undefined) {
                                        call_id = data['callId']
                                    }
                                    clearTimeout(reconnect_timeOut);
                                    clearTimeout(calling_back_timeOut)
                                    console.log(`Call back failed. Stop Ringing.....`)
                                    if (result.hasOwnProperty('message')) {
                                        current_call_status = 'call_failed'
                                        var ivr_call_msg = ``;
                                        var ivr_footer = false;
                                        if (call_id != '' && call_id != null && call_id != undefined) {
                                            ivr_footer = true;
                                            ivr_call_msg = `<br>Do you want to call their mobile number?`
                                        }
                                        let msg = `${result.message}${ivr_call_msg}`
                                        let message = "Failed to initiated the call to the user"
                                        let callback = () => { webData({ 'status': 'error', 'name': 'close_web_error', 'message': result.message, 'error': message, 'call_id': call_id, 'group_id': group_id, 'channel_id': channel_id, 'sl': '09', }) }
                                        showAlert({ title: getTranslatedText('inconvenience_title', language), message: msg, call_mobile_footer: ivr_footer, alertCallback: callback, error: true });
                                    }
                                    else {
                                        current_call_status = 'call_failed'
                                        let message = "Failed to initiated the call to the user"
                                        let callback = () => { webData({ 'status': 'error', 'name': 'close_web_error', 'message': result.message, 'error': message, 'call_id': call_id, 'group_id': group_id, 'channel_id': channel_id, 'sl': '09', }) }
                                        showAlert({ title: getTranslatedText('inconvenience_title', language), message: message, alertCallback: callback, error: true });
                                    }
                                }
                            },
                            error: function (xhr, status, error) {
                                console.error(xhr)
                                console.error(status)
                                console.error(error)
                                console.log(xhr.statusCode)
                                user_joined = ''
                                clearTimeout(reconnect_timeOut);
                                clearTimeout(calling_back_timeOut)
                                try {
                                    ringing_sound.volume = 0;
                                    ringing_sound.pause();
                                } catch { }
                                console.log(`Direct_call_failed error. Stop Ringing.....`)
                                if (xhr.status !== 0) {
                                    current_call_status = 'error'
                                    let message = "Fatching issue to initiated the call to the user"
                                    let callback = () => { webData({ 'status': 'error', 'name': 'close_web_error', 'message': message, 'error': "Server Error in /api/call_back", 'call_id': call_id, 'group_id': group_id, 'channel_id': channel_id, 'sl': '10', }) }
                                    showAlert({ title: getTranslatedText('inconvenience_title', language), message: message, alertCallback: callback, error: true });
                                }
                            }
                        });
                    updateCallStatus('Waiting')
                }

                else if (eventData.name === 'join_call') {
                    // Check URL parameters first, then eventData
                    if (url_call_id && url_call_id !== '' && call_id == '') {
                        call_id = url_call_id;
                    } else if (eventData.data.hasOwnProperty('call_id')) {
                        if (eventData.data['call_id'] != '' && eventData.data['call_id'] != null && eventData.data['call_id'] != undefined) {
                            if (call_id == '') call_id = eventData.data['call_id']
                        }
                    }

                    if (url_channel_id && url_channel_id !== '' && (channel_id == '' || channel_id == null || channel_id == undefined)) {
                        channel_id = url_channel_id;
                    } else if (eventData.data.hasOwnProperty('channel_id')) {
                        if (channel_id == '' || channel_id == null || channel_id == undefined) channel_id = eventData.data['channel_id']
                    }
                    ready_to_join = true;
                    const data = {
                        'mobile': mobile,
                        'user_id': user_id,
                        'user_type': user_type,
                        'call_id': call_id,
                        'channel_id': channel_id,
                        'group_id': group_id,
                    }
                    try {
                        $.post(`${api_base_url}/api/get-call-data`, data, function (response) {
                            console.log(`Response for call_data:`, response)
                            farmer_company = response['farmer_company'];
                            updateCallStatus('Ready')
                        });
                    } catch { }
                }
            }, false);
        }

        // function to initialise the SDK
        let init = async () => {
            console.log('SDK Initialized.')
            const registerEvents = async () => { // if !sdk_initialized
                sdk_initialized = true;
                console.log('Client event listener added')
                rtcClient.on("user-published", async (user, mediaType) => {
                    if (rtcClient.remoteUsers.length <= 1) {
                        await rtcClient.subscribe(user, mediaType);
                        console.log(`%cThe USER ${user.uid} PUBLISHED his/her ${mediaType}`, consoleCSS_green)
                        console.log(`%cThe joined users in the channel are: `, consoleCSS)
                        console.log(rtcClient.remoteUsers)
                        if (mediaType === "audio") {
                            user.audioTrack?.play();
                            user.audioTrack?.setVolume(100);
                            $(`#mute-audio-msg-${String(user.uid).replaceAll(/ /g, "_")}`).hide();

                            // // Create an audio context
                            // const audioContext = new (window.AudioContext)();
                            // // Get the MediaStreamTrack from the IRemoteAudioTrack
                            // const mediaStreamTrack = user.audioTrack?.getMediaStreamTrack();
                            // // Create a media stream source node from the MediaStreamTrack
                            // const mediaStream = new MediaStream();
                            // if(mediaStreamTrack){
                            //     mediaStream.addTrack(mediaStreamTrack);
                            //     const source = audioContext.createMediaStreamSource(mediaStream);
                            //     // Create a gain node to control the volume
                            //     const gainNode = audioContext.createGain();
                            //     gainNode.gain.value = 1; // Boost the volume by doubling it
                            //     // Connect the source to the gain node and the gain node to the audio context's destination (output)
                            //     source.connect(gainNode);
                            //     gainNode.connect(audioContext.destination);
                            //     console.log('Audio Boosted')
                            // }
                        }
                        if (mediaType === "video") {
                            $(`.recipients-live-videos-screen-${String(user.uid).replaceAll(/ /g, "_")}`).show();
                            const video_render_element = $(`#live-video-player-track-video-${String(user.uid).replaceAll(/ /g, "_")}`)
                            if (video_render_element.length) {
                                user.videoTrack?.play(`live-video-player-track-video-${String(user.uid).replaceAll(/ /g, "_")}`);
                                video_render_element.show();
                                console.log('Remote video showed')
                            }
                            else {
                                console.log('Force rendered to show remote video')
                                forceRender(renderSL => renderSL + 1)
                            }
                        }
                    }
                });
                rtcClient.on("user-unpublished", async (user, type) => {
                    await rtcClient.unsubscribe(user, type);
                    console.log(`%cThe USER ${user.uid} UNPUBLISHED his/her ${type}`, consoleCSS_red)
                    console.log(`%cThe joined users in the channel are: `, consoleCSS)
                    console.log(rtcClient.remoteUsers)
                    if (type === "audio") {
                        user.audioTrack?.stop();
                        if (rtcClient.remoteUsers.length == 1) {
                            $(`#mute-audio-msg-${String(user.uid).replaceAll(/ /g, "_")}`).show();
                            $(`#mute-audio-msg-${String(user.uid).replaceAll(/ /g, "_")}`).html(`<span class="remote_user_name_${String(user.uid).replaceAll(/ /g, "_")}">${remote_user_name[`${String(user.uid).replaceAll(/ /g, "_")}`]}</span> muted the audio`);
                        }
                        setAudioVolume(user.uid, 0);
                    }
                    if (type === "video") {
                        $(`.recipients-live-videos-screen-${String(user.uid).replaceAll(/ /g, "_")}`).hide();
                        user.videoTrack?.stop();
                        // forceRender(renderSL => renderSL+1)
                    }

                });
                rtcClient.on("user-joined", async (user) => {
                    remoteuser_joined = true;
                    console.log(`%cThe USER ${user.uid} has been JOINED into the channel`, consoleCSS_green)
                    console.log(`%cThe joined users in the channel are: `, consoleCSS)
                    console.log(rtcClient.remoteUsers)
                    clearTimeout(reconnect_timeOut)
                    clearTimeout(calling_back_timeOut)
                    try {
                        ringing_sound.volume = 0;
                        ringing_sound.pause();
                    } catch { }
                    if (!user.audioTrack?.isPlaying) {
                        $(`#mute-audio-msg-${String(user.uid).replaceAll(/ /g, "_")}`).show();
                        $(`#mute-audio-msg-${String(user.uid).replaceAll(/ /g, "_")}`).html(`<span class="remote_user_name_${String(user.uid).replaceAll(/ /g, "_")}">${remote_user_name[`${String(user.uid).replaceAll(/ /g, "_")}`]}</span> muted the audio`);
                    }

                    // recordVideo('start');
                    // try{
                    //     user.audioTrack?.play();
                    //     user.audioTrack?.setVolume(100);
                    // }catch{}
                    $(".alert-container").hide();
                    await rtcClient.setStreamFallbackOption(user.uid, 2) // Subscribe to the low-quality video stream when the network conditions worsen, and subscribe to audio only when the conditions become too poor to support video transmission.
                    joinedUsers[`${user.uid}`] = {
                        'userObject': user,
                        'name': user.uid,
                        'user_type': 'Receiver'
                    }
                    joined_users_array.push(user.uid)
                    console.log('JoinedUsers is: ', joinedUsers)
                    if (remote_user_joined == false) {
                        timer(reverse_timer, start_time);
                        updateCallStatus('Picked Up');
                    }
                    remote_user_joined = true;
                    if (rtcClient.remoteUsers.length == 1) {
                        total_joined_users = rtcClient.remoteUsers.length;
                        try {
                            window.navigator.vibrate([1000])
                        } catch { }
                        api_CallStatusUpdate('Started', user_id, 'remote_user-joined')
                        current_call_status = 'call_success'
                        forceRender(renderSL => renderSL + 1)
                    }
                    else if (rtcClient.remoteUsers.length == 2) {
                        total_joined_users = rtcClient.remoteUsers.length;
                        try {
                            window.navigator.vibrate([1000])
                        } catch { }
                        if (agent_call_id != '') api_AgentCallStatusUpdate('Started', user_id, 'remote_user-joined')
                        current_call_status = 'call_success'
                        forceRender(renderSL => renderSL + 1)
                    }

                });
                rtcClient.on("user-left", async (user, reason) => {
                    console.log(`%cThe USER ${user.uid} LEAVED the channel (${reason})`, consoleCSS_red)
                    console.log(`%cThe joined users in the channel are: `, consoleCSS)
                    if (reason === 'Quit') {
                        console.log(rtcClient.remoteUsers)
                        // let copiedUsers = JSON.parse(JSON.stringify(users));
                        const uid_index = joined_users_array.indexOf(user.uid)
                        joined_users_array.splice(uid_index, 1)
                        try {
                            delete joinedUsers[`${user.uid}`]
                        }
                        catch {

                        }
                        if (rtcClient.remoteUsers.length === 0) {
                            await leave_Channel('remote_user', false)
                        }
                        else {
                            forceRender(renderSL => renderSL + 1)
                        }
                    }
                    else {
                        let message = `<i class="fa-sharp fa-solid fa-spinner fa-spin"></i> Reconnecting.....`;
                        showAlert({ title: "User's Connection Lost", message: message, hide_close: true, error: false });
                    }
                });

                rtcClient.on("connection-state-change", async (curState, prevState, reason) => {
                    // if(reason != 'LEAVE'){
                    //     let message = `<i class="fa-sharp fa-solid fa-spinner fa-spin"></i> Reconnecting.....`;
                    //     showAlert({title:"You're Offline", message:message, hide_close:true, error:false});
                    // }
                    if (['DISCONNECTING', 'DISCONNECTED', 'RECONNECTING'].includes(curState)) {
                        user_disconnected = true;
                        if (!client_left) {
                            let message = `<i class="fa-sharp fa-solid fa-spinner fa-spin"></i> Reconnecting.....`;
                            showAlert({ title: "You're Offline", message: message, hide_close: true, error: false });
                        }
                    }
                    if (['CONNECTED'].includes(curState)) {
                        $(".alert-container").hide();
                        user_disconnected = false
                    }
                });

                // Reports the network quality of the local user. After the local user joins the channel, the SDK triggers this callback to report the uplink and downlink network conditions of the local user once every two second.
                rtcClient.on('network-quality', (network_stats) => {
                    const clientDownloadSpeed = network_stats.downlinkNetworkQuality
                    const clientUploadSpeed = network_stats.uplinkNetworkQuality
                    showNetworkQuality(uid, network_stats, true);
                    // console.log(`Your Download Quality is: ${clientDownloadSpeed}. || Yor Upload Quality is: ${clientUploadSpeed}.`)
                    // if(clientDownloadSpeed <= 2 && network_downstream_speed !== 'good'){ //good
                    //   network_downstream_speed = 'good'
                    //   rtcClient.remoteUsers.forEach(async(remoteUsers) => {
                    //     await rtcClient.setStreamFallbackOption(remoteUsers.uid, 0) // Disable the fallback.
                    //     // await rtcClient.setRemoteVideoStreamType(remoteUsers.uid, 0)
                    //   })
                    // }
                    // else if(clientDownloadSpeed <= 4 && network_downstream_speed !== 'medium'){ //medium
                    //   network_downstream_speed = 'medium'
                    //   rtcClient.remoteUsers.forEach(async(remoteUsers) => {
                    //     await rtcClient.setStreamFallbackOption(remoteUsers.uid, 1) // Automatically subscribe to the low-video stream under poor network conditions.
                    //     // await rtcClient.setRemoteVideoStreamType(remoteUsers.uid, 1)
                    //   })
                    // }
                    // else if(network_downstream_speed !== 'bed'){ //bed
                    //   network_downstream_speed = 'bed'
                    //   rtcClient.remoteUsers.forEach(async(remoteUsers) => {
                    //     await rtcClient.setStreamFallbackOption(remoteUsers.uid, 2) // Subscribe to the low-quality video stream when the network conditions worsen, and subscribe to audio only when the conditions become too poor to support video transmission.
                    //   })
                    // }
                })

                // Occurs when a remote video stream falls back to an audio stream due to unreliable network conditions or switches back to video after the network conditions improve.
                rtcClient.on('stream-fallback', async (uid, isFallbackOrRecover) => {
                    try {
                        if (isFallbackOrRecover === 'fallback') {
                            // console.log(`%cRemote stream of user ${uid} falls back to an audio stream due to unreliable network conditions`, consoleCSS_red)
                            $(`.recipients-live-videos-screen-${String(uid).replaceAll(/ /g, "_")}`).hide();
                            joinedUsers[`${uid}`]['userObject'].videoTrack?.stop();
                            await rtcClient.unsubscribe(joinedUsers[`${uid}`]['userObject'], 'video');
                        }
                        if (isFallbackOrRecover === 'recover') {
                            // console.log(`%cRemote stream of user ${uid} switches back to video stream as network conditions improved`, consoleCSS_green)
                            // joinedUsers[uid]['userObject'].videoTrack?.stop();
                            await rtcClient.subscribe(joinedUsers[`${uid}`]['userObject'], 'video');
                            joinedUsers[`${uid}`]['userObject'].videoTrack?.play(`live-video-player-track-video-${String(uid).replaceAll(/ /g, "_")}`);
                            $(`.recipients-live-videos-screen-${String(uid).replaceAll(/ /g, "_")}`).show();
                        }
                    }
                    catch (e) {
                        console.error(e)
                    }
                    finally {
                        // forceRender(renderSL => renderSL+1)
                    }
                })
                // Occurs when the type of a remote video stream changes. The SDK triggers this callback when a high-quality video stream changes to a low-quality video stream, or vice versa.
                rtcClient.on('stream-type-changed', async (uid, streamType) => {
                    try {
                        // console.log(`%cRemote video stream quality of user ${uid} changed due to changes in network quality`, consoleCSS_green)
                        joinedUsers[`${uid}`]['userObject'].videoTrack?.stop();
                        await rtcClient.subscribe(joinedUsers[`${uid}`]['userObject'], 'video');
                        joinedUsers[`${uid}`]['userObject'].videoTrack?.play(`live-video-player-track-video-${String(uid).replaceAll(/ /g, "_")}`);
                        $(`.recipients-live-videos-screen-${String(uid).replaceAll(/ /g, "_")}`).show();
                        // forceRender(renderSL => renderSL+1)
                    }
                    catch (e) {
                        console.error(e)
                    }
                })
                rtcClient.enableAudioVolumeIndicator();
                rtcClient.on("volume-indicator", async function (result) {
                    result.forEach(function (volume, index) {
                        // console.log(`${index} UID ${volume.uid} Level ${volume.level}`);
                        setAudioVolume(volume.uid, volume.level);
                    });
                });

                if (true) { // !remote_network_check_started
                    remote_network_check_started = true;
                    clearInterval(network_interval)
                    network_interval = setInterval(function () {
                        let network = rtcClient.getRemoteNetworkQuality();
                        Object.entries(network).forEach(([userId, quality]) => {
                            showNetworkQuality(userId, quality);
                        });
                    }, 1000);
                }



                // rtmClient.addEventListener("message", event => {
                //     console.log("rtmClient message:", event)
                //     const channelType = event.channelType; // The channel type. Should be "STREAM" or "MESSAGE" .
                //     const channelName = event.channelName; // The channel this message comes from
                //     const topic = event.topicName; // The Topic this message comes from, it is valid when the channelType is "STREAM".
                //     const messageType = event.messageType; // The message type. Should be "STRING" or "BINARY" .
                //     const customType = event.customType; // User defined type
                //     const publisher = event.publisher; // Message publisher
                //     const message = event.message; // Message payload
                //     const pubTime = event.publishTime; // Message publisher timestamp

                //     if(String(message).includes('Full Name:')){
                //         const f_name = String(message).replace('Full Name: ', '')
                //         remote_user_name[publisher] = f_name

                //         $(`.remote_user_name-${publisher}`).html(f_name);
                //         $(`.remote_user_name_${publisher}`).html(f_name);
                //     }
                // });

                // try {
                //     const result = await rtmClient.login();
                //     await rtmClient.subscribe(channel_id);
                // } catch (status) {
                //     console.log("error: rtmClient.login/subscribe -", status);
                // }
            }

            if (ready_to_join && user_joined == '0' && app_data_received && rtcClient.remoteUsers.length === 0 && user_call_api_status_started === false && remoteuser_joined === false) {
                user_joined = '1';
                try {
                    await rtcClient.leave();
                } catch { }
                // try {
                //     await rtmClient.logout();
                // }catch {}
                try {
                    rtcClient.removeAllListeners();
                } catch { }
                // try {
                //     rtmClient.removeAllListeners();
                // }catch {}
                try {
                    await registerEvents()
                } catch { }
                try {
                    await rtcClient.enableDualStream()
                } catch { }
                try {
                    // If a remote user enables dual-stream mode, after using this method, local RTC Client will subscribe the specified streamType by default. The local RTC client subscribes to the high-quality video stream by default.
                    await rtcClient.setRemoteDefaultVideoStreamType(0) // By default subscribe High-bitrate, high-resolution video stream
                } catch { }

                await rtcClient.join(appId, channel_id, token, uid);
                console.log(`%cHey ${uid}, YOU have successfully JOINED into the channel - ${channel_id}.`, consoleCSS_green)
                if (rtcClient.remoteUsers.length >= 0) {
                    if (local_tracks) await rtcClient.publish(local_tracks);
                    console.log(`%cThe joined users in the channel are: `, consoleCSS)
                    console.log(rtcClient.remoteUsers)
                    joinedUsers[`${uid}`] = {
                        'userObject': rtcClient,
                        'name': uid,
                        'user_type': 'Caller'
                    }
                    console.log('JoinedUsers is: ', joinedUsers)

                    const message = `Full Name: ${full_name}`;
                    const payload = { type: "text", message: message };
                    const publishMessage = JSON.stringify(payload);
                    // try {
                    //     const result = await rtmClient.publish(channel_id, publishMessage);
                    //     console.log("result: rtmClient.publish -", result);
                    // } catch (status) {
                    //     console.log("error: rtmClient.publish -", status);
                    // }

                    // @ts-ignore
                    if (user_call_api_status_started === false && (!is_caller && !is_call_back) && rtcClient.remoteUsers.length >= 1) {
                        try {
                            ringing_sound.volume = 0;
                            ringing_sound.pause();
                        } catch { }
                        api_CallStatusUpdate('Started', user_id, 'Client-joined')
                        current_call_status = 'call_success'
                        timer(reverse_timer, start_time);
                    }
                    if (rtcClient.remoteUsers.length == 0) {
                        updateCallStatus('Initiated');
                    }
                    else {
                        updateCallStatus('Picked Up');
                    }
                }
                // else{
                //     valid_user = false;
                //     rtcClient.removeAllListeners();
                //     await rtcClient.leave();
                //     current_call_status = 'call_failed'
                //     try{
                //         ringing_sound.volume = 0;
                //         ringing_sound.pause();
                //     }catch{}
                //     console.log(`Another vet picked Stop Ringing.....`)
                //     clearTimeout(reconnect_timeOut);
                //     clearTimeout(calling_back_timeOut)
                //     let message = "The call is already picked up by an another vet."
                //     let callback = () => {webData({ 'status': 'error', 'name': 'close_web_error', 'message': message, 'error': message, 'call_id': call_id, 'group_id': group_id, 'channel_id': channel_id, 'sl': '11',})}
                //     showAlert({title:getTranslatedText('inconvenience_title', language), message:message, alertCallback:callback, error:true});
                // }
            }
        };

        if (tracks_ready && callStatus != 'Failed') { // if mic and camera is ready
            init();
        }

        if (!data_loaded && tracks_ready) {
            $(".loading_message").html(`Please Wait.....`);
            let u_id = String(Math.random().toString(36).slice(2)).substring(0, 5);

            // Check for URL parameters first (only if not using existing encrypted params)
            const urlParamTriggered = (using_url_params && !has_page) ? triggerUrlParameterCall() : false;

            if (!urlParamTriggered) {
                // Fallback to existing logic if no URL parameters or URL params failed validation
                console.log("Using existing logic (Android injection or encrypted params)");
                if (is_caller) {
                    request_data['request'] = 'call_initiated'
                    request_data['name'] = 'start_call'
                    user_type = 'Caller'
                }
                else if (is_call_back) {
                    request_data['request'] = 'call_initiated'
                    request_data['name'] = 'call_back'
                    user_type = 'Caller'
                }
                else {
                    request_data['request'] = 'call_received'
                    request_data['name'] = 'join_call'
                    user_type = 'Receiver'
                }

                if (use_form) {
                    // Keep existing form logic
                }
                else {
                    webData(request_data)
                }
            }

            data_loaded = true;
        }
    }); //[channel_id, callStatus, tracks_ready, ready_to_join]
    console.log(`%cThe Current CALL Status-2 is: ${callStatus}\nIs Caller ${is_caller}`, consoleCSS)
    return (
        <div>
            {<AlertDialog />}
            <div className="App">
                {(!has_page || using_url_params) && <div></div>}
                {!has_page && !using_url_params && user_form_submitted === false && rtcClient.remoteUsers.length === 0 && is_caller === true && use_form === true && source === 'self' && <UserForm />}
                {(!has_page || using_url_params) && !['Picked Up', 'Ended', 'Failed'].includes(callStatus) && rtcClient.remoteUsers.length === 0 && (is_caller || is_call_back) && <CallerVideoFullScreen />}
                {(!has_page || using_url_params) && !['Picked Up', 'Ended', 'Failed'].includes(callStatus) && rtcClient.remoteUsers.length === 0 && (is_caller || is_call_back || (using_url_params && (url_start_call || url_join_call))) && <CallingScreen class_name={'calling-screen-new'} />}
                {(!has_page || using_url_params) && !['Picked Up', 'Ended', 'Failed'].includes(callStatus) && rtcClient.remoteUsers.length === 0 && (is_caller || is_call_back || (using_url_params && (url_start_call || url_join_call))) && <CallingScreen class_name={'calling-screen-new-1'} />}
                {(!has_page || using_url_params) && rtcClient.remoteUsers.length > 0 && <TopBar remote_users={rtcClient.remoteUsers} />}
                {(!has_page || using_url_params) && <RemoteUserVideo />}
                {(!has_page || using_url_params) && tracks_ready && rtcClient.remoteUsers.length > 0 && <CallerVideo />}
                {(!has_page || using_url_params) && tracks_ready && (running_on_android || user_form_submitted || using_url_params) && <Controls callStatus={callStatus} updateCallStatus={updateCallStatus} renderSL={renderSL} forceRender={forceRender} />}
                {/* Debug info for UI visibility */}
                {console.log("UI render conditions:", {
                    has_page,
                    tracks_ready,
                    running_on_android,
                    user_form_submitted,
                    using_url_params,
                    url_start_call,
                    url_join_call,
                    callStatus,
                    remoteUsersCount: rtcClient.remoteUsers.length,
                    is_caller,
                    is_call_back,
                    shouldShowControls: (!has_page || using_url_params) && tracks_ready && (running_on_android || user_form_submitted || using_url_params),
                    shouldShowCallingScreen: (!has_page || using_url_params) && !['Picked Up', 'Ended', 'Failed'].includes(callStatus) && rtcClient.remoteUsers.length === 0 && (is_caller || is_call_back || (using_url_params && (url_start_call || url_join_call)))
                })}
            </div>
        </div>
    );
};

const UserForm = (props: any) => {
    console.log('%cComponent: UserForm', consoleCSS_yellow)
    let languageListViewJSX: any[] = [];
    available_languages.forEach((lang) => {
        languageListViewJSX.push(
            <div className="language-list-item" data-value={lang[0]}>{lang[1]}</div>
        )
    });

    let animalListViewJSX: any[] = [];
    for (const key in available_animals) {
        let listed_animals = available_animals[key]
        let animalListViewJSX1: any[] = [];
        for (let i = 0; i < listed_animals.length; i++) {
            animalListViewJSX1.push(
                <div className={`animal-list-item animal_${listed_animals[i]}`} data-value={listed_animals[i]}>{listed_animals[i]}</div>
            )
        }
        animalListViewJSX.push(
            <div className="animal-list-sec">
                <div className={`animal-list-type animal_type_${key}`}>{key}</div>
                <div className="animal-list-item-sec">{animalListViewJSX1}</div>
                <hr></hr>
            </div>
        )
    }

    let form_html = <div id="user-form-div">
        <div className="row text-center">
            <div className="col-md text-center">
                <div id="user-form-box">
                    <div className="language-list">
                        <div className="language_list_heading" id="language_list_heading">{getTranslatedText('language_list_heading', language)}</div>
                        <div className="language_list_sub_heading" id="language_list_sub_heading">
                            {getTranslatedText('language_list_sub_heading', language)}
                        </div>
                        {languageListViewJSX}
                    </div>

                    <div className="animal-list" style={{ display: 'none' }}>
                        <div className="animal_list_heading" id="animal_list_heading">{getTranslatedText('animal_list_heading', language)}</div>
                        <div className="animal_list_sub_heading" id="animal_list_sub_heading">{getTranslatedText('animal_list_sub_heading', language)}</div>
                        {animalListViewJSX}
                    </div>

                    <form id="user-form" autoComplete="off" style={{ display: 'none' }}>
                        <div className="user-form-section">
                            <div>
                                <label className="user-form-label" htmlFor="input_mobile" id="input_mobile_label">{getTranslatedText('input_mobile_label', language)}</label>
                            </div>
                            <div>
                                <input type="tel" className="user-form-input" id="input_mobile" placeholder="10 digit mobile no" form="user-form" required minLength={10} maxLength={10} defaultValue={readCookies('mobile')} />
                            </div>
                        </div>

                        <div className="user-form-section">
                            <div>
                                <label className="user-form-label" htmlFor="input_name" id="input_name_label">{getTranslatedText('input_name_label', language)}</label>
                            </div>
                            <div>
                                <input type="text" className="user-form-input" id="input_name" placeholder="Your name" form="user-form" required defaultValue={readCookies('farmer_name')} />
                            </div>
                        </div>

                        <div className="user-form-section">
                            <button type="submit" className="user-form-submit" id="input_submit" form="user-form">{getTranslatedText('input_submit', language)}</button>

                            {!tracks_ready &&
                                <div id="permission_text">
                                    <span id="permission_text_1">
                                        {getTranslatedText('permission_text_1', language)}
                                    </span>
                                    <div className="contact-us-link-div"><a className="contact-us-link" href="https://wa.me/1XXXXXXXXXX?text=I'm%20interested%20in%20your%20car%20for%20sale" title="Contact Us">Contact Us</a></div>
                                </div>
                            }
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    return form_html
}


const TopBar = (props: any) => {
    return <div className="top-fixed-bar"></div>
}

const CallingScreen = (props: any) => {
    const { class_name, } = props;
    console.log('%cComponent: CallingScreen', consoleCSS_yellow)
    // Only play ringing sound for non-URL parameter calls or when appropriate
    if (!using_url_params && (user_form_submitted || !use_form)) {
        ringing_sound.play()
        ringing_sound.volume = 1;
    } else if (using_url_params && app_data_received && (user_form_submitted || !use_form)) {
        ringing_sound.play()
        ringing_sound.volume = 1;
    }
    let html = <></>;
    const hang_on = getTranslatedText('hang_on', language);
    const please_wait = getTranslatedText('please_wait', language);
    const vet_will_be_there = getTranslatedText('vet_will_be_there', language);
    const paravet_will_be_there = getTranslatedText('paravet_will_be_there', language);
    const user_will_be_there = getTranslatedText('user_will_be_there', language);
    const call_record_disclaimer = getTranslatedText('call_record_disclaimer', language);

    // Custom message for URL parameter calls
    let calling_text = '';
    if (using_url_params && url_start_call) {
        calling_text = 'Waiting for Vet to Join';
        console.log('CallingScreen: Using URL parameter message - Waiting for Vet to Join');
    } else if (using_url_params && url_join_call) {
        calling_text = 'Connecting to Call...';
        console.log('CallingScreen: Using URL parameter message - Connecting to Call...');
    } else {
        // Existing logic for other call types
        if (!app_data_received) {
            calling_text = please_wait;
        } else if (app_data_received && is_caller && !is_paravet_call && !is_call_back && !is_direct_call) {
            calling_text = vet_will_be_there;
        } else if (app_data_received && is_caller && is_paravet_call && !is_call_back && !is_direct_call) {
            calling_text = paravet_will_be_there;
        } else if (app_data_received && is_call_back && (!is_direct_call && !is_follow_up_call)) {
            calling_text = user_will_be_there;
        } else if (app_data_received && (is_direct_call || is_follow_up_call)) {
            calling_text = user_will_be_there;
        }
    }

    html = <div className={class_name}>
        <div className="top-bar">
            Calling
        </div>
        {/* <div className="calling-icon">
                    <img src={require("../public/images/giphy.gif").default} alt=""/>
                </div> */}
        <div className="calling-heading">
            {hang_on}
        </div>
        <div className="calling-text">
            {calling_text}
        </div>
        <div className="disclaimer">
            <div className="disclaimer-box">
                <div className="disclaimer-text">
                    {call_record_disclaimer}
                </div>
            </div>
        </div>
        <div className="credit">
            <div className="credit-box d-flex justify-content-center">
                <div className="credit-text">Powered by DrPashu Technologies</div>
            </div>
        </div>
    </div>
    return html
}
const CallerVideoFullScreen = (props: any) => {
    if (local_tracks) {
        // local_tracks[1].play('id-caller-video')
        let ret = <></>;
        ret = <div>
            <div className="caller-video-screen">
                <LiveVideoPlayer className="caller-video-full-screen" id="id-caller-video-full" videoTrack={local_tracks[1]} userid={uid} />
            </div>
        </div>
        return ret;
    }
    else {
        return <></>
    }
}

const RemoteUserVideo = (props: {
    // remote_users: IAgoraRTCRemoteUser[];
}) => {
    console.log(`%cComponent: RemoteUserVideo - The USER are to be shown:`, consoleCSS)
    // console.log(props.remote_users)
    const [name, setName] = useState('');
    if (rtcClient.remoteUsers.length == 0) {
        return <div className="div-remote-users-view">
            <div className="blank-remote-users-view">
                <div className="play-icon">
                    <i className="fa-sharp fa-regular fa-circle-play"></i>
                    <div className="loading-text">
                        {!app_data_received && "Please wait"}
                        {app_data_received && "Connecting....."}
                    </div>
                </div>
            </div>
        </div>
    }
    else if (rtcClient.remoteUsers.length == 1) {
        video_loaded = true;
        try {
            ringing_sound.volume = 0;
            ringing_sound.pause();
        } catch { }

        // var mergedViewJSX: any[] = [];
        // remote_users.forEach((remoteUser) => {
        //     mergedViewJSX.push(
        //         <div id={`remote-user-view-${String(remoteUser.uid).replaceAll(/ /g, "_")}`}>
        //             <div className="remote-volume-indicator" id={`volume-indicator-${String(remoteUser.uid).replaceAll(/ /g, "_")}`}>
        //                 <div className="off-background"></div><div className="on-background"></div>
        //             </div>
        //             <div className="mute-audio-msg" id={`mute-audio-msg-${String(remoteUser.uid).replaceAll(/ /g, "_")}`}></div>
        //             <RemoteNetworkIndicator remoteUser={remoteUser}/>
        //             <MuteVideoView remoteUser={remoteUser} />
        //             {remoteUser.videoTrack && <LiveVideoView remoteUser={remoteUser} />}
        //         </div>
        //     )
        // });

        // IVR popover removed

        const html = <div className="div-remote-users-view">
            <div id={`remote-user-view-${String(rtcClient.remoteUsers[0].uid).replaceAll(/ /g, "_")}`}>
                <div className="remote-volume-indicator" id={`volume-indicator-${String(rtcClient.remoteUsers[0].uid).replaceAll(/ /g, "_")}`}>
                    <div className="off-background"></div><div className="on-background"></div>
                </div>
                <div className="mute-audio-msg" id={`mute-audio-msg-${String(rtcClient.remoteUsers[0].uid).replaceAll(/ /g, "_")}`}></div>
                <RemoteUserNetworkIndicator remoteUser={rtcClient.remoteUsers[0]} />
                <SingleRemoteUserMuteVideoView remoteUser={rtcClient.remoteUsers[0]} />
                {rtcClient.remoteUsers[0].videoTrack &&
                    <div className={"single-recipients-live-videos-screen recipients-live-videos-screen-" + String(rtcClient.remoteUsers[0].uid).replaceAll(/ /g, "_")}>
                        <LiveVideoPlayer className="recipients-videos" id={`live_video_player-${String(rtcClient.remoteUsers[0].uid).replaceAll(/ /g, "_")}`} videoTrack={rtcClient.remoteUsers[0].videoTrack} userid={rtcClient.remoteUsers[0].uid} />
                        <div className={`single-video-recipients-name remote_user_name-${String(rtcClient.remoteUsers[0].uid).replaceAll(/ /g, "_")}`}>{remote_user_name[`${String(rtcClient.remoteUsers[0].uid).replaceAll(/ /g, "_")}`]}</div>
                    </div>}
            </div>
        </div>

        return html
    }
    else if (rtcClient.remoteUsers.length == 2) {
        const html = <div className="two-user-video-sec">
            <div className="live-video-box" id="live-video-box-1">
                <div className={`video-user-name remote_user_name-${String(rtcClient.remoteUsers[0].uid).replaceAll(/ /g, "_")}`}>{remote_user_name[`${String(rtcClient.remoteUsers[0].uid).replaceAll(/ /g, "_")}`]}</div>
                <LiveVideoPlayer className={"two-user-live-video recipients-live-videos-screen-" + String(rtcClient.remoteUsers[0].uid).replaceAll(/ /g, "_")} id={`live_video_player-${String(rtcClient.remoteUsers[0].uid).replaceAll(/ /g, "_")}`} videoTrack={rtcClient.remoteUsers[0].videoTrack} userid={rtcClient.remoteUsers[0].uid} />
            </div>
            <div className="live-video-box" id="live-video-box-2">
                <div className={`video-user-name remote_user_name-${String(rtcClient.remoteUsers[1].uid).replaceAll(/ /g, "_")}`}>{remote_user_name[`${String(rtcClient.remoteUsers[1].uid).replaceAll(/ /g, "_")}`]}</div>
                <LiveVideoPlayer className={"two-user-live-video recipients-live-videos-screen-" + String(rtcClient.remoteUsers[1].uid).replaceAll(/ /g, "_")} id={`live_video_player-${String(rtcClient.remoteUsers[1].uid).replaceAll(/ /g, "_")}`} videoTrack={rtcClient.remoteUsers[1].videoTrack} userid={rtcClient.remoteUsers[1].uid} />
            </div>
        </div>

        return html;
    }
};

const SingleRemoteUserMuteVideoView = (props: any) => {
    console.log('%cComponent: MuteVideoView', consoleCSS_yellow)
    return (
        <div className="single-recipients-mute-videos-screen" id={"recipients-mute-videos-screen-" + String(props.remoteUser.uid).replaceAll(/ /g, "_")}>
            <div id="on-call">ON CALL</div>
            <div><i className="fa-solid fa-circle-user avatar-icons"></i></div>
            <div className={`recipient_name remote_user_name remote_user_name-${String(rtcClient.remoteUsers[0].uid).replaceAll(/ /g, "_")}`}>{remote_user_name[`${String(rtcClient.remoteUsers[0].uid).replaceAll(/ /g, "_")}`]}</div>
        </div>
    );
}

const CallerVideo = (props: any) => {
    console.log('%cComponent: CallerVideo', consoleCSS_yellow)
    if (local_tracks) {
        // local_tracks[1].play('id-caller-video')
        let ret = <></>;
        ret = <div>
            <div className="caller-video-screen">
                <LiveVideoPlayer className="caller-video" id="id-caller-video" videoTrack={local_tracks[1]} userid={uid} />
            </div>
            <div className="local-volume-indicator" id={`volume-indicator-${String(uid).replaceAll(/ /g, "_")}`}>
                <div className="off-background"></div>
                <div className="on-background"></div>
            </div>
            <LocalNetworkIndicator />
        </div>
        return ret;
    }
    else {
        return <></>
    }
}

const LiveVideoPlayer = (props: any) => {
    console.log(`%cComponent: LiveVideoPlayer of ${props.userid}`, consoleCSS_yellow, props)
    const videoRef = useRef<HTMLVideoElement>(null);
    useEffect(() => {
        try {
            props.videoTrack.stop();
            props.videoTrack.play(videoRef.current);
            console.log('Video track played');
        }
        catch { }
    }, [props.videoTrack]);

    return <div id={`user-video-${props.id}`} className={props.className}>
        <div id={`live-video-player-track-${props.userid}`} className="live-video-player-track">
            <video ref={videoRef} autoPlay playsInline muted id={`live-video-player-track-video-${props.userid}`} className="live-video-player-track-video"></video>
        </div>
    </div>
}

const LocalNetworkIndicator = (props: any) => {
    const html = <div className={`local-signal-icon signal-icon-${uid}`}>
        <div className="download">
            <div className="signal-bar"></div>
            <div className="signal-bar"></div>
            <div className="signal-bar"></div>
            <div className="signal-bar"></div>
            <div className="signal-bar"></div>
        </div>
        <div className="down-up-arrow">
            <i className="fa-regular fa-arrow-down arrow-down-icon"></i>&nbsp;<i className="fa-regular fa-arrow-up arrow-up-icon"></i>
        </div>
        <div className="upload">
            <div className="signal-bar"></div>
            <div className="signal-bar"></div>
            <div className="signal-bar"></div>
            <div className="signal-bar"></div>
            <div className="signal-bar"></div>
        </div>
    </div>
    return html;
}
const RemoteUserNetworkIndicator = (props: any) => {
    const html = <div className={`remote-signal-icon signal-icon-${props.remoteUser.uid}`}>
        <div className="download">
            <div className="signal-bar"></div>
            <div className="signal-bar"></div>
            <div className="signal-bar"></div>
            <div className="signal-bar"></div>
            <div className="signal-bar"></div>
        </div>
        <div className="down-up-arrow">
            <i className="fa-regular fa-arrow-down arrow-down-icon"></i>&nbsp;<i className="fa-regular fa-arrow-up arrow-up-icon"></i>
        </div>
        <div className="upload">
            <div className="signal-bar"></div>
            <div className="signal-bar"></div>
            <div className="signal-bar"></div>
            <div className="signal-bar"></div>
            <div className="signal-bar"></div>
        </div>
    </div>
    return html;
}

const leavechannel = async () => {
    await leave_Channel('client', false);
};
const leave_Channel = async (leaved_by = 'client', confirmation = true) => {
    // const rtcClient = useClient();
    if (confirmation && leaved_by == 'client') {
        let message = "Do you want to end the call?"
        let callback = () => { leavechannel() }
        showAlert({ title: "", message: message, hide_close: true, yes_no_footer: true, alertCallback: callback, error: false });
        return true;
    }
    else {
        try {
            client_left = true;
            var total_remote_users = rtcClient.remoteUsers.length
            $(".App").html('')
            let message = `<i class="fa-regular fa-spinner-third fa-spin"></i> Disconnecting.....`;
            showAlert({ title: "", message: message, hide_close: true, error: true });
            console.log(`${leaved_by} leaved the channel`);
            // await recordVideo('end');
            clearTimeout(calling_back_timeOut)
            clearTimeout(reconnect_timeOut)
            clearInterval(timer_interval);
            clearInterval(waiting_call_fetch_interval);
            rtcClient.removeAllListeners();
            // rtmClient.removeAllListeners();
            await rtcClient.leave();
            // await rtmClient.logout();
            // we close the tracks to perform cleanup
            if (local_tracks) local_tracks[0].close();
            if (local_tracks) local_tracks[1].close();
            if (user_call_api_status_started && !user_agent_call_api_status_started && !user_call_api_status_ended) {
                await api_CallStatusUpdate('Ended', user_id, `${leaved_by}-leaved`)
            }
            else if (user_agent_call_api_status_started && !user_call_api_status_ended) {
                if (total_remote_users == 2) {
                    await api_CallStatusUpdate('Ended', user_id, `${leaved_by}-leaved`)
                }
                else if (total_remote_users == 1) {
                    await api_CallStatusUpdate('Ended', user_id, `${leaved_by}-leaved`)
                    await api_AgentCallStatusUpdate('Ended', user_id, `${leaved_by}-leaved`)
                }
            }
            if (user_call_api_status_started === false && !call_rejected && total_remote_users == 0 && (is_caller || is_call_back) && leaved_by == 'client') {
                current_call_status = 'call_rejected'
                await api_rejectCall()
            }
            console.log(`%cYou successfully LEAVED the channel`, consoleCSS_red);
        }
        catch (e) {
            console.log(e)
        }
        finally {
            try {
                ringing_sound.volume = 0;
                ringing_sound.pause();
            } catch { }
            console.log(`${leaved_by} ended call.`)
            console.log("current_call_status", current_call_status);
            if (current_call_status === 'call_success') {
                current_call_status = 'call_complete'
                webData({ 'status': 'call_success', 'name': 'call_complete', 'message': 'The call is ended.', 'call_id': call_id, 'group_id': group_id, 'channel_id': channel_id, 'edit_prescription': edit_prescription, 'farmer_number': farmer_mobile, 'vet_number': vet_mobile });
            }
            else if (current_call_status !== 'call_complete') {
                current_call_status = 'call_complete'
                webData({ 'status': 'error', 'name': 'close_web_error', 'message': 'Call ended forcefully', 'error': `Call ended forcefully`, 'call_id': call_id, 'group_id': group_id, 'channel_id': channel_id, 'sl': '13', });
            }
        }
    }
};

const Controls = (props: {
    // tracks: [IMicrophoneAudioTrack, ICameraVideoTrack];
    callStatus: any;
    updateCallStatus: React.Dispatch<React.SetStateAction<string>>;
    // camera: string;
    // changeCamera: React.Dispatch<React.SetStateAction<any>>;
    renderSL: number;
    forceRender: React.Dispatch<React.SetStateAction<number>>;
}) => {
    console.log('%cComponent: Controls', consoleCSS_yellow, props)
    console.log('Controls component: local_tracks available:', !!local_tracks)
    console.log('Controls component: tracks_ready:', tracks_ready)
    console.log('Controls component: using_url_params:', using_url_params)
    var [cameraChanged, changedCamera] = useState(cameraVideoTrackConfig.facingMode);
    var [speakerChanged, changedSpeaker] = useState(seted_microphone_label);
    // const rtcClient = useClient();
    const { callStatus, updateCallStatus, renderSL, forceRender } = props;
    var audio_muted = true
    var video_muted = true
    if (local_tracks) {
        audio_muted = local_tracks[0].muted;
        video_muted = local_tracks[1].muted;
    }
    const [trackState, setTrackState] = useState({ audio: !audio_muted, video: !video_muted });
    if (local_tracks || using_url_params) {
        const mute = async (type: "audio" | "video") => {
            if (type === "audio" && local_tracks) {
                await local_tracks[0].setMuted(!local_tracks[0].muted);
                // await local_tracks[0].setEnabled(!local_tracks[0].enabled);
                const mute_state = local_tracks[0].muted ? 'MUTED' : "UNMUTED"
                const mute_color = local_tracks[0].muted ? consoleCSS_red : consoleCSS_green
                console.log(`%cComponent: Controls - You have ${mute_state} your ${type}`, mute_color)
                setTrackState((ps) => {
                    return { ...ps, audio: !ps.audio };
                });
            }
            else if (type === "video" && local_tracks) {
                await local_tracks[1].setMuted(!local_tracks[1].muted);
                // await local_tracks[1].setEnabled(!local_tracks[1].enabled);
                const mute_state = local_tracks[1].muted ? 'MUTED' : "UNMUTED"
                const mute_color = local_tracks[1].muted ? consoleCSS_red : consoleCSS_green
                console.log(`%cComponent: Controls - You have ${mute_state} your ${type}`, mute_color)
                setTrackState((ps) => {
                    return { ...ps, video: !ps.video };
                });
                try {
                    if (!local_tracks[1].muted) {
                        // recordVideo('resume');
                        if (!['Picked Up', 'Ended', 'Failed'].includes(callStatus) && rtcClient.remoteUsers.length === 0 && (is_caller || is_call_back)) {
                            $(".calling-screen-new").hide();
                            $(".calling-screen-new-1").show();
                            $(".caller-video-full-screen").show();
                        }
                        else {
                            $('.caller-video').show();
                        }
                        document.getElementById('btn-cameara-toggle')!.style.pointerEvents = 'auto';
                    }
                    else {
                        // recordVideo('pause');
                        if (!['Picked Up', 'Ended', 'Failed'].includes(callStatus) && rtcClient.remoteUsers.length === 0 && (is_caller || is_call_back)) {
                            $(".calling-screen-new").show();
                            $(".calling-screen-new-1").hide();
                            $(".caller-video-full-screen").hide();
                        }
                        else {
                            $('.caller-video').hide();
                        }
                        document.getElementById('btn-cameara-toggle')!.style.pointerEvents = 'none';
                    }
                }
                catch (e) {
                    // console.log(e);
                }
            }
        };
        const toggleCamera = async () => {
            if (local_tracks) {
                if (!local_tracks[1].muted && local_tracks[1].enabled) {
                    // recordVideo('stop');
                    await rtcClient.unpublish(local_tracks[1])
                    local_tracks[1].close()
                    // local_tracks[1].unpipe()
                    cameraVideoTrackConfig.facingMode = cameraVideoTrackConfig.facingMode === 'user' ? 'environment' : 'user'
                    const newCameraVideoTrack = await AgoraRTC.createCameraVideoTrack(cameraVideoTrackConfig)
                    local_tracks[1] = newCameraVideoTrack
                    local_tracks[1].play(`live-video-player-track-video-${String(uid).replaceAll(/ /g, "_")}`)
                    rtcClient.publish(local_tracks[1])
                    // recordVideo('start');
                    changedCamera(cameraVideoTrackConfig.facingMode)
                }
                return cameraChanged
            }
        }
        const toggleSpeaker = async () => {
            // set_microphone = true;
            seted_microphone_label = seted_microphone_label === 'Speaker' ? 'Headset earpiece' : 'Speaker';
            const temp_array = seted_microphone_label.split(" ")
            AgoraRTC.getMicrophones(false).then((devices) => {
                media_devices = devices;
                console.log('Media devices are: ', devices);
                devices.forEach(async (device) => {
                    if (device.kind != 'videoinput') {
                        const mic_label = device.label.toLowerCase().replaceAll(' ', '')
                        temp_array.some(async (label) => {
                            label = label.toLowerCase().replaceAll(' ', '');
                            if (mic_label.includes(label)) {
                                if (local_tracks) {
                                    await rtcClient.unpublish(local_tracks[0]);
                                    local_tracks[0].setDevice(device.deviceId);
                                    console.log('Microphone set to:', device);
                                    rtcClient.publish(local_tracks[0]);
                                    changedSpeaker(seted_microphone_label);
                                    return 1;
                                }
                            }
                        })
                    }
                });
            });
        }
        const leaveChannel = async () => {
            await leave_Channel('client', true);
            // showTost("Call Ended")
            // closeWeb('Ended')
            // return <CloseWindow/>
        };

        window.addEventListener("beforeunload", (event) => {
            if (running_on_android == false && client_left == false) {
                // Modern way to show confirmation dialog
                event.preventDefault();
                // Most modern browsers will show a generic confirmation message
                // The custom message is ignored for security reasons
                return "Do you want to end the call?";
            }
            try {
                ringing_sound.volume = 0;
                ringing_sound.pause();
            } catch { }
        });
        console.log("Controls component: Rendering controls div");
        return (
            <div className="controls" style={{
                position: 'fixed',
                bottom: '0px',
                left: '0px',
                right: '0px',
                zIndex: 999999999,
                backgroundColor: 'rgba(177, 177, 177, 0.9)',
                display: 'block',
                visibility: 'visible'
            }}>

                <div className="control-panels" style={{ backgroundColor: 'rgb(177, 177, 177)', width: '100%', padding: '6px' }}>
                    <div className="row text-center gap-0 p-0 m-0" style={{ padding: '0px', margin: '0px', gap: '0px' }}>
                        {/* <div className="col-1 p-0 m-0" style={{ padding: '0px', margin: '0px' }}></div> */}
                        <div className="col p-0 m-0" style={{ padding: '0px', margin: '0px' }}>
                            <div className={seted_microphone_label === 'Speaker' ? "btn-control btn-speaker enabled" : "btn-control btn-speaker disabled"} onClick={() => toggleSpeaker()} id="btn-speaker-toggle" style={{ padding: '0px', margin: '0px' }}>
                                {seted_microphone_label === 'Speaker' ? <FontAwesomeStack icon="fa-solid fa-volume fa-stack-1x fa-inverse" style={{ color: '#424242' }} title="Switch to ear" /> : <FontAwesomeStack icon="fa-light fa-ear-listen fa-stack-1x fa-inverse" style={{ color: '#5d5555' }} title="Switch to speaker" />}
                            </div>
                        </div>
                        {navigator.mediaDevices.getSupportedConstraints().facingMode &&
                            <div className="col p-0 m-0" style={{ padding: '0px', margin: '0px' }}>
                                <div className={cameraVideoTrackConfig.facingMode === 'user' ? "btn-control btn-camera front" : "btn-control btn-camera rear"} onClick={() => toggleCamera()} id="btn-cameara-toggle" style={{ padding: '0px', margin: '0px' }}>
                                    {cameraVideoTrackConfig.facingMode === 'user' ? <FontAwesomeStack icon="fa-solid fa-camera-rotate fa-stack-1x fa-inverse" style={{ color: '#424242' }} title="Switch to Rear Camera" /> : <FontAwesomeStack icon="fa-solid fa-camera-rotate fa-stack-1x fa-inverse" style={{ color: '#cfcfcf' }} title="Switch to Front Camera" />}
                                </div>
                            </div>}
                        <div className="col p-0 m-0" style={{ padding: '0px', margin: '0px' }}>
                            <div className="btn-control btn-leave" onClick={() => leaveChannel()} style={{ padding: '0px', margin: '0px' }}>
                                <FontAwesomeStack icon="fa-solid fa-phone-hangup fa-stack-1x fa-inverse" style={{ color: 'red' }} title="End Call" />
                            </div>
                        </div>
                        <div className="col p-0 m-0" style={{ padding: '0px', margin: '0px' }}>
                            <div className={local_tracks && !local_tracks[1].muted ? "btn-control btn-video on" : "btn-control btn-video"} onClick={() => local_tracks && mute("video")} style={{ padding: '0px', margin: '0px' }}>
                                {local_tracks && !local_tracks[1].muted ? <FontAwesomeStack icon="fa-light fa-video fa-stack-1x fa-inverse" style={{ color: '#0acd0d' }} title="Mute Video" /> : <FontAwesomeStack icon="fa-light fa-video-slash fa-stack-1x fa-inverse" style={{ color: '#ff1d1d' }} title="Unmute Video" />}
                            </div>
                        </div>
                        <div className="col p-0 m-0" style={{ padding: '0px', margin: '0px' }}>
                            <div className={local_tracks && !local_tracks[0].muted ? "btn-control btn-audio on" : "btn-control btn-audio"} onClick={() => local_tracks && mute("audio")} style={{ padding: '0px', margin: '0px' }}>
                                {local_tracks && !local_tracks[0].muted ? <FontAwesomeStack icon="fa-light fa-microphone fa-stack-1x fa-inverse" style={{ color: '#0acd0d' }} title="Mute Audio" /> : <FontAwesomeStack icon="fa-light fa-microphone-slash fa-stack-1x fa-inverse" style={{ color: '#ff1d1d' }} title="Unmute Audio" />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    else {
        console.log("Controls component: local_tracks not available and not using URL params, returning empty component");
        return <></>
    }
};


const FontAwesomeStack = (props: any) => {
    // Use FontAwesome CSS classes with fallback to emojis
    const iconClass = props.icon;
    let symbol = '?'; // emoji fallback
    let faIcon = 'fa-question'; // FontAwesome fallback

    // Map the icon classes
    if (iconClass.includes('fa-volume')) {
        symbol = '🔊';
        faIcon = 'fa-volume-up';
    } else if (iconClass.includes('fa-ear-listen')) {
        symbol = '🎧';
        faIcon = 'fa-headphones';
    } else if (iconClass.includes('fa-camera-rotate')) {
        symbol = '🔄';
        faIcon = 'fa-sync-alt';
    } else if (iconClass.includes('fa-phone-hangup')) {
        symbol = '�';
        faIcon = 'fa-phone-slash';
    } else if (iconClass.includes('fa-video-slash')) {
        symbol = '🚫📹';
        faIcon = 'fa-video-slash';
    } else if (iconClass.includes('fa-video')) {
        symbol = '📹';
        faIcon = 'fa-video';
    } else if (iconClass.includes('fa-microphone-slash')) {
        symbol = '🚫🎤';
        faIcon = 'fa-microphone-slash';
    } else if (iconClass.includes('fa-microphone')) {
        symbol = '🎤';
        faIcon = 'fa-microphone';
    }

    return (
        <span className="fa-stack btn-stack" style={props.style}>
            <i className="fa-solid fa-circle fa-stack-2x circle-stack"></i>
            <i className={`fa-solid ${faIcon} fa-stack-1x fa-inverse`}></i>
            {/* Fallback emoji if FontAwesome doesn't load */}
            <span
                className="emoji-fallback"
                style={{
                    position: 'absolute',
                    fontSize: '16px',
                    display: 'none'
                }}
            >
                {symbol}
            </span>
        </span>
    );
}

const closeWindow = () => {
    window.opener = null;
    window.open('', '_self');
    window.close();
    return null;
}
const CloseWindow = (props: any) => {
    closeWindow();
    return <></>
}


// $(document).on('click', function(){
//     $(".start-ivr-call-btn-popover").hide();
// });



// ----------------------------------------------------------------------------------------------------------------

$("#send-otp-btn").on('click', function (e) {
    clearInterval(interval1);
    let mobile_no = $("#otp-input-mobile").val();
    $("#otp_verify_msg").html('&nbsp');
    $("#otp-input-value").val("");
    $("#otp_send_msg").html('&nbsp');
    $("#otp_send_msg").removeClass("text-error");
    $("#otp_send_msg").removeClass("text-done");

    if (mobile_no == '') {
        $("#otp_send_msg").html("Please enter your mobile number.");
        $("#otp_send_msg").addClass("text-error");
    }
    else if (String(mobile_no).length != 10) {
        $("#otp_send_msg").html("Please enter your 10 digit mobile number.");
        $("#otp_send_msg").addClass("text-error");
    }
    else {
        $(this).prop('disabled', true);
        $(this).html("Sending OTP...");
        $("#otp-input-mobile").prop('disabled', true);
        $("#otp-input-value").prop('disabled', true);
        $("#verify-btn").prop("disabled", true);
        $.ajax(
            {
                type: 'POST',
                url: `${api_base_url}/api/webview_send_verify_otp`,
                data: {
                    mobile_no: mobile_no,
                },
                dataType: 'json',
                cache: false,
                crossDomain: true,
                success: function (result, status, xhr) {
                    $("#send-otp-btn").html("Resend OTP");
                    if (result['status'] == true) {
                        $("#otp_send_msg").html("OTP sent to your mobile.");
                        $("#otp_send_msg").addClass("text-done");
                        $("#otp-input-value").prop('disabled', false);
                        $("#otp-input-value").trigger('focus');
                        $("#verify-btn").prop("disabled", false);
                        $("#change-mobile").css('visibility', 'visible');
                        timer1(60);
                    }
                    else {
                        $("#otp_send_msg").html("Failed to send OTP. Please try again.");
                        $("#otp_send_msg").addClass("text-error");
                        $("#send-otp-btn").prop('disabled', false);
                        $("#otp-input-mobile").prop('disabled', false);
                    }
                },
                error: function (xhr, status, error) {
                    $("#send-otp-btn").html("Resend OTP");
                    $("#otp_send_msg").html("Failed to send OTP. Please try again.");
                    $("#otp_send_msg").addClass("text-error");
                    $("#send-otp-btn").prop('disabled', false);
                    $("#otp-input-mobile").prop('disabled', false);
                }
            });
    }
});

$("#otp-input-value").on('keyup', function (e) {
    const val = String($(this).val())
    if (val.length >= 4 && e.key !== "Backspace" && e.key !== "Delete") {
        console.log("Blur otp-input-value")
        $(this).trigger('blur');
    }
});

$("#verify-btn").on('click', function (e) {
    let otp = $("#otp-input-value").val();
    if (otp == '') {
        $("#otp_verify_msg").html("Please enter your OTP");
        $("#otp_verify_msg").addClass("text-error");
    }
    else {
        $(this).prop('disabled', true);
        $(this).html("Verifying OTP...");
        $("#otp_verify_msg").html('&nbsp');
        $("#otp-input-value").prop('disabled', true);
        $("#otp_verify_msg").removeClass("text-error");
        $("#otp_verify_msg").removeClass("text-done");
        let mobile_no = $("#otp-input-mobile").val();
        var next_screen = "call_history"
        $.ajax(
            {
                type: 'POST',
                url: `${api_base_url}/api/webview_send_verify_otp`,
                data: {
                    mobile_no: mobile_no,
                    otp: otp,
                    next_screen: next_screen
                },
                dataType: 'json',
                cache: false,
                crossDomain: true,
                success: function (result, status, xhr) {
                    // $("#verify-btn").html("Verified");
                    if (result['status'] == true) {
                        $("#otp_verify_msg").html("OTP verified successfully");
                        $("#otp_verify_msg").addClass("text-done");
                        // $(".non-call-contents").show();
                        $(".otp-div").hide();
                        clearInterval(interval1);
                        sessionStorage.setItem("User_id", result["User_id"]);
                        sessionStorage.setItem("mobile_number", result["mobile_number"]);
                        if (next_screen == "call_history") {
                            console.log("loadCallHistory")
                            loadCallHistory()
                        }
                    }
                    else {
                        $("#otp_verify_msg").html(result['message']);
                        $("#otp_verify_msg").addClass("text-error");
                        $("#otp-input-value").prop('disabled', false);
                        $("#verify-btn").prop('disabled', false);
                        $("#verify-btn").html("Next");
                    }
                },
                error: function (xhr, status, error) {
                    $("#otp_verify_msg").html("Failed to verify OTP");
                    $("#otp_verify_msg").addClass("text-error");
                    $("#otp-input-value").prop('disabled', false);
                    $("#verify-btn").prop('disabled', false);
                    $("#verify-btn").html("Next");
                }
            });
    }
});

function resetOTPFields() {
    $("#otp_send_msg").html('&nbsp');
    $("#otp_verify_msg").html('&nbsp');
    $("#otp-input-mobile").prop('disabled', false);
    $("#send-otp-btn").prop('disabled', false);
    $("#otp-input-value").val('');
    $("#otp-input-value").prop('disabled', true);
    $("#verify-btn").prop('disabled', true);
    $("#verify-btn").html("Next")
    $("#otp-input-mobile").trigger('focus');
    $("#send-otp-btn").html(`Send OTP`);
    $("#change-mobile").css('visibility', 'hidden');
}
$("#change-mobile").on("click", function (e) {
    resetOTPFields()
    clearInterval(interval1);
});


var interval1;
function timer1(t1) {
    interval1 = setInterval(function () {
        if (t1 <= 0) {
            $("#send-otp-btn").prop('disabled', false);
            $("#send-otp-btn").html(`Resend OTP`);
            clearInterval(interval1);
        }
        else if (t1 > 0) {
            $("#send-otp-btn").prop('disabled', true);
            $("#send-otp-btn").html(`Resend OTP (<span style="font-size:14px;">${t1}s</span>)`);
            t1 = t1 - 1;
        }
    }, 1000);
}

var logo = "/public/images/drpashu_logo.png"

var ic_ivr = "/public/images/ic_ivr.PNG"
var icon_prescription = "/public/images/icon_prescription.png"
var icon_instruction = "/public/images/icon_instruction.png"
var no_prescription = "/public/images/no_prescription.png"

var call_in_done = "/public/images/call_in_done.png"
var call_in_miss = "/public/images/call_in_miss.png"
var call_out_done = "/public/images/call_out_done.png"
var call_out_miss = "/public/images/call_out_miss.png"

var camera_icon = "/public/images/camera.jpg"


function loadCallHistory() {
    $(".stick-header").show();
    $(".loader-common").show();
    $(".non-call-container-items").hide();
    $(".call-history-div").show();
    const targetURL = `${site_url}/?page=call_history`
    window.history.pushState({ page: 2 }, "Call History", targetURL);
    console.log(`Loading: ${targetURL}`)
    $(".call-histories").html('')
    $.ajax(
        {
            type: 'GET',
            url: `${api_base_url}/api/call_history`,
            headers: {
                'User-id': sessionStorage.getItem("User_id")
            },
            data: {

            },
            dataType: 'json',
            cache: false,
            crossDomain: true,
            success: function (result, status, xhr) {
                $(".loader-common").hide();
                if (result['status'] == true) {
                    const calls = result['data'];
                    if (calls.length > 0) {
                        for (let call of calls) {
                            var call_status_full = call['call_status_full']
                            var call_prescription_status = call['call_prescription_status']
                            let profile_pic = logo
                            if (call['profile_picture'] != null) {
                                profile_pic = call['profile_picture'];
                            }
                            var call_type = ''
                            if (String(call['call_initiated']).toLowerCase() == String(result['user_type']).toLowerCase()) {
                                call_type = 'call_out'
                            }
                            else {
                                call_type = 'call_in'
                            }
                            let res_html = `<div class="row call-details-row" data-call_id="${call['id']}">
                                            <div class="col">
                                                <div class="d-flex align-items-center justify-content-start">
                                                    <img src="${profile_pic}" class="profile-icon" />
                                                    <div class="call-info">
                                                        <div class="user-name">${call['first_name']} ${call['last_name']}</div>
                                                        <div class="date-time">${call['time']}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-auto">
                                                <div class="call-status-icon-div">
                                                    ${call['call_type'] == 'Offline' ? `<img src="${ic_ivr}" class="call-status-icon ivr_call-icon" />` : ''}
                                                    ${call_prescription_status != null ? `<img src="/public/images/icon_${call_prescription_status}.png" class="call-status-icon call_prescription_status-icon" />` : ``}
                                                    ${call_status_full != null ? `<img src="/public/images/${call_status_full}.png" class="call-status-icon call_prescription_status-icon" />` : ``}
                                                </div>
                                            </div>
                                        </div>
                                        <hr>`;
                            $(".call-histories").append(res_html);
                        }
                    }
                    else {

                    }
                }
                else {
                    $(".loader-common").hide();
                }
            },
            error: function (xhr, status, error) {
                $(".loader-common").hide();
            }
        });
}

function loadCallDetails(callId) {
    $(".stick-header").show();
    $(".loader-common").show();
    const targetURL = `${site_url}/?page=call_details&call_id=${callId}`
    window.history.pushState({ page: 2 }, "Call Details", targetURL);

    $.ajax(
        {
            type: 'POST',
            url: `${api_base_url}/api/call_details`,
            headers: {
                'User-id': sessionStorage.getItem("User_id")
            },
            data: {
                call_id: callId,
            },
            dataType: 'json',
            cache: false,
            crossDomain: true,
            success: function (result, status, xhr) {
                if (result['status'] == true) {
                    $(".non-call-container-items").hide();
                    $(".call-details-div").show();
                    $(".loader-common").hide();
                    const result_data = result['data'];

                    let res_data = {}
                    for (let key in result_data) {
                        if (result_data[key] == null) {
                            res_data[key] = ''
                        }
                        else {
                            res_data[key] = result_data[key]
                        }
                    }
                    group_id = res_data['group_id']
                    full_name = `${res_data['first_name']} ${res_data['last_name']}`
                    call_id = res_data['id']
                    if (res_data['call_status_res'] == 'Completed') {
                        $(".call-status-heading").addClass("call-success")
                        $(".call-status-heading").removeClass("call-failed")
                        $(".call-status-mark").html("Success")
                        $(".call-status-text").html("You have completed the call")
                    }
                    else {
                        $(".call-status-heading").removeClass("call-success")
                        $(".call-status-heading").addClass("call-failed")
                        $(".call-status-mark").html("Failed")
                        $(".call-status-text").html("You were unable to connect")
                    }

                    $(".call-info-animal").html(res_data['animal'])
                    if (res_data['profile_picture'] == '') {
                        $(".user-photo-img").attr('src', logo)
                    }
                    else {
                        $(".user-photo-img").attr('src', `${res_data['profile_picture']}`)
                    }
                    $(".call-username").html(`${res_data['first_name']} ${res_data['last_name']}`);
                    let call_duration = res_data['call_duration']
                    if (call_duration != '') {
                        call_duration = `(${call_duration})`
                    }
                    $(".call-timestamp").html(`${res_data['date']} ${res_data['time']} ${call_duration}`)

                    let btn_1 = true
                    let btn_2 = true
                    if (res_data['follow_up'] == false) {
                        $(".call-back-btn").hide()
                        btn_1 = false
                    }
                    else {
                        $(".call-back-btn").show()
                        btn_1 = true
                    }
                    if (res_data['call_status_res'] != 'Completed') {
                        $(".call-chat-btn").hide();
                        btn_2 = false
                    }
                    else {
                        $(".call-chat-btn").show();
                        btn_2 = true
                    }
                    if (btn_1 == false && btn_2 == false) {
                        $(".call-button-div").hide();
                    }
                    else {
                        $(".call-button-div").show();
                    }

                    if (res_data['prescription_uploaded'] == true) {
                        $(".prescription-details-div").show();
                        $(".prescription-img-div").show();

                        if (res_data['Prescription_image_first'] == '') {
                            $(".Prescription_image_first").attr('src', `${camera_icon}`)
                        }
                        else {
                            $(".Prescription_image_first").attr('src', `${res_data['Prescription_image_first']}`)
                        }
                        if (res_data['Prescription_image_second'] == '') {
                            $(".Prescription_image_second").attr('src', `${camera_icon}`)
                        }
                        else {
                            $(".Prescription_image_second").attr('src', `${res_data['Prescription_image_second']}`)
                        }
                    }
                    else {
                        $(".prescription-details-div").hide();
                        $(".prescription-img-div").hide();
                    }

                    $("#symptoms").val(res_data['symptoms'])
                    $("#treatments").val(res_data['details'])
                    if (res_data['diagnosis_other'] == '') {
                        $("#diagnosis").val(res_data['diagnosis'])
                    }
                    else {
                        $("#diagnosis").val(res_data['diagnosis_other'])
                    }

                    $(".prescription-products-row").html('')
                    let product_html = ''
                    for (let product of res_data['products']) {
                        let product_img = logo
                        if (product['image'] != '') {
                            product_img = product['image']
                        }
                        product_html += `<div class="col-6">
                                            <div class="prescription-product-item text-center">
                                                <img class="product-img" src="${product_img}">
                                                <div class="product-title text-start">
                                                    ${product['title']}
                                                </div>
                                                <div class="product-desc text-start text-truncate">
                                                    ${product['benefit']}
                                                </div>
                                            </div>
                                        </div>`
                    }
                    $(".prescription-products-row").html(product_html)
                }

            },
            error: function (xhr, status, error) {

            }
        });
}

$(document).on('click', ".call-details-row", function () {
    let cId = $(this).data('call_id');
    loadCallDetails(cId)
});


var session_user_id = sessionStorage.getItem("mobile_number")
console.log(`user_id: ${session_user_id}`)
if (session_user_id != null && session_user_id != undefined && session_user_id != "") {
    if (look_page == 'call_history') {
        console.log("loadCallHistory")
        loadCallHistory();
    }
    else if (look_page == 'call_details' && url_query_data['call_id'] != '' && url_query_data['call_id'] != null && url_query_data['call_id'] != undefined) {
        loadCallDetails(url_query_data['call_id'])
    }
    else if (has_page) {
        console.log("loadCallHistory")
        loadCallHistory();
    }
}
else if (has_page) {
    $(".stick-header").hide();
    $(".otp-div").show();
}

$(".call-back-btn").on('click', function () {
    const originalText = `name=${farmer_name}&group_id=${group_id}&call_id=${call_id}`
    const cipherText = CryptoJS.AES.encrypt(originalText, key, { mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString();
    const call_back_url = `${site_url}?is_caller=false&source=web&call_back=true&value=${cipherText}`
    window.location.replace(call_back_url)
});

$("#logout-btn").on('click', function () {
    sessionStorage.removeItem("mobile_number");
    sessionStorage.removeItem("user_id");

    resetOTPFields();

    $(".stick-header").hide();
    $(".non-call-container-items").hide();
    $(".otp-div").show();
});

$("#menu-btn").on("click", function () {
    $(".option-dropdown-items").toggleClass("show");
});
$(document).on('click', function (event) {
    if (!$(event.target).closest("#menu-btn").length) {
        // If the clicked element is not inside div2, hide div1
        $(".option-dropdown-items").removeClass("show");
    }
});


$(".call-chat-btn").on('click', function () {
    showAlert({ title: "", message: "Chat feature is only available in DrPashu mobile app.", hide_close: false, error: false });
})

$(".Prescription_image_icon").on('click', function () {
    let img_for = $(this).data('image');
    console.log(img_for)
    $(`#modal-${img_for}`).show();
});
$(".modal-Prescription_image-close-btn").on('click', function () {
    $(".modal-Prescription_image").hide()
})

if (has_page) {
    $(".non-call-contents").show();
    $(".loader-container").hide();
}

window.onpopstate = function (event) {
    console.log("Back or forward button pressed.");
    console.log("Current state:", event.state);
    console.log(`Current url: ${window.location.href}`)
    if (event.state) {
        window.location.reload();
    }
};

export default App;